import { SVGOverlay } from "react-leaflet";
import { ImageBounds, globalStyle } from './sharedSVGProperties';


export const coldWarMaps = {
    dieMaschine: (
        <SVGOverlay attributes={{ viewBox: '0 0 512 512' }} bounds={ImageBounds}>
            <defs>
                <style>
                    {globalStyle}
                    {`
                .d{strokeMiterlimit:10;}
                .d{strokeWidth:0.96px;}
                `}
                </style>
            </defs>
            <rect className="a background-fill" width="512" height="512" />
            <polyline
                className="b field-fill"
                points="77.44 262.72 81.92 255.68 87.36 252.16 92.8 252.16 101.12 247.36 103.68 243.84 116.32 244 120.16 249.76 131.36 249.76 136.16 252.32 136.16 259.04 139.36 263.84 144.8 263.84 153.12 252.32 162.4 255.84 172.96 257.12 187.68 276.96 192.8 272.8 194.08 269.6 192.8 265.44 185.54 257.2 203.04 239.84 200.05 232.66 205.6 219.36 210.72 216.16 210.72 211.36 206.56 210.08 196 188.96 197.6 185.76 206.56 181.28 209.44 177.12 196 164 197.6 160.8 204.64 155.36 203.04 145.76 197.92 141.28 208.16 130.72 214.88 136.16 220.32 141.28 224.8 143.2 229.6 141.28 238.88 148 254.88 148 262.24 145.76 267.36 131.04 272.12 126.51 281.44 126.56 289.76 120.16 297.76 120.16 296.16 107.04 288.48 98.72 289.76 89.44 318.56 73.44 343.84 86.56 345.44 100.64 348.32 106.08 361.12 111.84 376.16 103.52 395.36 127.52 395.36 148 384.48 156.64 378.08 152.48 368.48 150.88 360.8 157.28 363.68 164 370.72 170.4 374.24 186.72 381.6 201.44 357.28 228.32 357.28 267.04 373.6 297.12 366.24 306.72 368.8 316 374.24 321.44 385.12 319.52 394.08 333.28 404.64 355.68 406.24 363.68 407.52 367.52 407.52 375.84 405.28 383.2 396 391.2 391.84 392.48 389.6 380.64 396 374.24 396 367.52 390.56 372 361.44 384.16 352.8 408.8 320.8 408.8 291.68 384.16 254.88 383.52 254.47 337.59 197.85 337.79 190.24 324 186.72 314.72 182.24 312.48 176.8 313.44 177.76 319.52 174.24 331.68 154.08 330.4 132.51 330.39 113.76 325.6 114.72 319.84 111.84 308 109.6 303.84 103.84 306.72 100.96 316 79.84 297.12 83.04 284 72.48 267.68" />
            <path
                className="c building-fill"
                d="M394.64,385a12.37,12.37,0,0,0-1-3c-.41,0-2.3,3.93-1.95,4.05.19.08,1.05.58,1.91,1.13a5.57,5.57,0,0,0,1.71.87A16.4,16.4,0,0,0,394.64,385Zm-3.84,7.3a.41.41,0,0,0-.15.55c.3.48.51.39.51-.22C391.16,392.32,391,392.18,390.8,392.29Zm0-1.74c-.19-.12-.35,0-.35.33s.16.54.35.54a.34.34,0,0,0,.35-.33A.77.77,0,0,0,390.81,390.55Zm0-1.74c0-.29-.16-.52-.35-.52s-.35.23-.35.52.16.52.35.52S390.81,389.1,390.81,388.81Zm-.44-1.68a1.15,1.15,0,0,0-.05-.84c-.38-.38-.64.23-.37.85S390.23,387.74,390.37,387.13Zm-.26-2.15c0-.29-.15-.52-.35-.52s-.34.23-.34.52.15.52.34.52S390.11,385.27,390.11,385Zm-.48-1.57c.07,0,.13-.23.13-.52s-.15-.52-.33-.52-.25.24-.14.52S389.55,383.41,389.63,383.41Zm.13-2.24c0-.08-.15-.25-.34-.36s-.35-.05-.35.15a.37.37,0,0,0,.35.37C389.61,381.33,389.76,381.26,389.76,381.17ZM380.46,349c-2-5.46-3.74-10-3.81-10.07s-10.89,3.05-11.2,3.31,7.71,21.72,8,21.72a4.15,4.15,0,0,0,1.07-.33c.44-.18,2.88-1.07,5.43-2,3.78-1.33,4.59-1.74,4.41-2.19S382.48,354.41,380.46,349Zm-28.4-58.25-2.26-.57-3.88,2.17c-3.85,2.16-3.88,2.18-3.67,3.29a10.25,10.25,0,0,1-.4,3.38,8.71,8.71,0,0,0-.45,2.39c3.52,2.76,5.87,3.85,9.49,4.38.15,0,.58-.65,1-1.49a11.79,11.79,0,0,1,2.76-3.39L356.7,299l-.87-3.13C354.56,291.25,354.64,291.36,352.06,290.71Zm-1.95,52.81-4.5-1.79-2.8,2.13c-2.51,1.91-2.82,2.27-3,3.53-.35,2.3.82,3.87,5.43,7.33,3.88,2.9,4,3,5.72,2.87l1.74-.11.95-5.22c.52-2.87.95-5.61.95-6.09C354.6,345.38,354.21,345.15,350.11,343.52Zm-7.64-167.78-6.22,2.86a44.84,44.84,0,0,0-6,3c0,.17,2.92,6.09,6.49,13.17,4.82,9.58,6.61,12.82,7,12.67s2.35-1.48,4.61-3.06l4.11-2.87-.66-1.74-4.88-13C344.58,180.68,342.59,175.68,342.47,175.74Zm-11-11.06a.88.88,0,0,0,.25.82c.31.32.69.11,1.63-.93a46.86,46.86,0,0,1,3.52-3.33,15.15,15.15,0,0,1,2.6-2,12.47,12.47,0,0,1,2.28,2l2,2,2.64-2.36a21.27,21.27,0,0,0,2.61-2.58c0-.11-2.05-2-4.52-4.17a51.05,51.05,0,0,1-4.5-4.25c0-.16.78-2.08,1.74-4.28s1.74-4.08,1.74-4.19S336,133.88,330.88,129l-2.32-2.19-8.79,7.69-8.78,7.7-5.9-5.83-5.9-5.84-.82,1c-.69.87-.74,1.08-.31,1.32a1,1,0,0,0,.88.06c.45-.28,1.27.5,18.7,17.56C325.35,158.08,331.59,164.44,331.5,164.68Zm2.05,148.15-4,1.74-4,1.73-.76,5.06c-.67,4.52-.86,5.2-1.8,6.39l-1.05,1.33.41,2.28.43,2.28h4.93l4.52-3.87c2.49-2.13,4.62-4,4.74-4.25a38.65,38.65,0,0,0,1-4l.78-3.61-2.56-2.53Zm-18.06-203.3,2.42,1.35a16,16,0,0,0,2.8,1.37,19.62,19.62,0,0,0,3.13-3.53c1.51-2,2.88-3.76,3-4s-.49-1.71-2.17-4.31a24.69,24.69,0,0,1-2.15-3.63c.17.11.22-.16.11-.58s-.27-.59-.34-.37a.45.45,0,0,1-.62.22,21,21,0,0,0-4.17.42l-3.7.61-1,1.43-1,1.42,1.8,4.81Zm8,62.66c.43-.32.79-.65.79-.75a2.09,2.09,0,0,0-.31-.67c-.23-.37-.44-.4-.78-.13s-1.84-.92-6.55-5.35c-11.83-11.13-12.36-11.57-12.36-10.28,0,.25,4.14,4.35,9.21,9.11C322.6,172.65,322.74,172.75,323.52,172.19Zm-3.87-76.28c.08,0,.15-.16.15-.35a.36.36,0,0,0-.37-.35c-.2,0-.27.16-.15.35S319.56,95.91,319.65,95.91ZM293.7,144.62c-3.51-2.87-4.09-3.77-3.07-4.78.33-.33.33-.52,0-.84-.67-.67-1.56.5-1.6,2.09,0,1.33.08,1.46,3.79,4.52s4.36,3.39,4.36,2.34A17.82,17.82,0,0,0,293.7,144.62Zm-14.62,11a65.43,65.43,0,0,0-5.35,4.16l-5.05,4.15.43,1.07c.24.58,1.6,3.92,3,7.42a40.42,40.42,0,0,0,2.92,6.35c.19,0,3.6-1.51,7.58-3.35s7.25-3.4,7.25-3.46C289.87,171.57,279.33,155.6,279.08,155.6Zm-5.38,22.8c-.08,0-.25.16-.37.35s0,.35.16.35a.37.37,0,0,0,.37-.35C273.86,178.56,273.79,178.4,273.7,178.4Zm-2.2,1.33c-.09.25.07.33.41.2s.55-.36.55-.55C272.46,178.92,271.67,179.21,271.5,179.73Zm-1.38.42c-.44,0-.79.15-.79.34,0,.43.37.43,1,0C270.8,180.22,270.75,180.15,270.12,180.15Zm-1.81.69a.73.73,0,0,0-.54.35c-.12.19,0,.34.32.34s.55-.15.55-.34A.34.34,0,0,0,268.31,180.84Zm-.39-15.67a.36.36,0,0,0,.37-.34c0-.19-.07-.35-.16-.35s-.25.16-.36.35S267.72,165.17,267.92,165.17Zm-1.72.87c-.27.33-.3.53-.07.53a.84.84,0,0,0,.61-.37C267.11,165.59,266.68,165.46,266.2,166Zm-.7,16.23c0,.36.11.38.84.1.3-.12.47-.34.37-.51C266.49,181.5,265.5,181.83,265.5,182.27Zm-1-14.84c-.28.33-.31.53-.07.53a.84.84,0,0,0,.6-.37C265.37,167,264.94,166.85,264.47,167.43Zm-.17,15.15c-.29,0-.54.16-.54.35a.34.34,0,0,0,.33.34.72.72,0,0,0,.54-.34C264.75,182.74,264.6,182.58,264.3,182.58Zm-1.57-13.76c-.28.33-.3.53-.07.53a.8.8,0,0,0,.59-.37C263.63,168.37,263.2,168.25,262.73,168.82Zm-.14,14.45a1,1,0,0,0-.74.35c-.12.19,0,.35.3.35a1,1,0,0,0,.74-.35C263,183.43,262.87,183.27,262.59,183.27Zm-1.41-13.36c-.3.12-.55.37-.55.55,0,.46.79.17,1-.35C261.68,169.86,261.52,169.78,261.18,169.91Zm-.73,14.28c-.28.11-.52.34-.52.5s.24.21.52.1.53-.33.53-.5S260.74,184.08,260.45,184.19Zm-1-12.89c-.3.12-.55.37-.55.56,0,.45.79.17,1-.36C259.94,171.25,259.78,171.17,259.44,171.3ZM258.56,185c-.39,0-.71.16-.71.35s.22.35.5.35a.89.89,0,0,0,.71-.35C259.18,185.17,259,185,258.56,185Zm-.43-12.16c.08-.26-.05-.39-.31-.3a1.06,1.06,0,0,0-.6.61c-.09.26,0,.39.3.3A1.11,1.11,0,0,0,258.13,172.85Zm-1.31,12.86a.75.75,0,0,0-.54.35c-.12.19,0,.35.33.35s.54-.16.54-.35A.34.34,0,0,0,256.82,185.71Zm-.74-11.77a1.09,1.09,0,0,0-.6.61c-.09.26,0,.39.3.3a1.09,1.09,0,0,0,.61-.6C256.47,174,256.35,173.86,256.08,173.94Zm-1.56,12.47c-.28,0-.5.15-.5.35s.32.34.71.34.62-.15.51-.34A.91.91,0,0,0,254.52,186.41Zm.19-10.86c0-.46-.79-.17-1,.35-.09.25.07.33.41.2S254.71,175.74,254.71,175.55Zm-2.35,9.61c-.24.24.25.9.68.9.23,0,.2-.2-.07-.53S252.45,185.07,252.36,185.16Zm.61-8.58c0-.2-.23-.16-.52.08a1.38,1.38,0,0,0-.52.78c0,.2.23.16.52-.08A1.38,1.38,0,0,0,253,176.58Zm-2.12,7c-.17,0-.32.24-.32.52a.52.52,0,0,0,.52.53c.31,0,.43-.21.31-.53S251,183.62,250.85,183.62Zm0-4.7a.91.91,0,0,0,.35-.73c0-.29-.15-.43-.35-.31a1,1,0,0,0-.35.74C250.53,178.9,250.69,179,250.88,178.92Zm0,1.92c.2,0,.35-.24.35-.52s-.15-.52-.35-.52-.35.23-.35.52S250.69,180.84,250.88,180.84Zm0,2.09c.2,0,.35-.24.35-.53s-.15-.52-.35-.52-.35.24-.35.52S250.69,182.93,250.88,182.93Zm-15.48,6.23-6.1.22a35.78,35.78,0,0,0-6.52.59c-.24.19-.44.22-.45.05s-.17,0-.37.31-.54.51-.77.38-.29-.11-.15.06c.35.38-1.84,2.64-2.29,2.36-.19-.12-.24,0-.11.17s-.06.54-.42.74c-.59.31-.62.52-.3,1.93.45,1.95,1,2.42,7.85,6.31l5.09,2.91,2.44-.22c2.35-.22,2.52-.3,4.62-2.17s2.17-2,2.17-3.64c0-1.44-.34-2.29-2.35-5.84ZM203.89,137v4.68l2.34-2.25c1.29-1.24,2.41-2.29,2.5-2.34a13.61,13.61,0,0,0-2.34-.09Zm3.14-5.57c.19,0,.35-.07.35-.15s-.16-.25-.35-.37-.35,0-.35.15A.37.37,0,0,0,207,131.41Zm-1.23,1.4c.29-.24.44-.57.33-.75-.28-.44-.84,0-.84.63C205.29,133.14,205.38,133.16,205.8,132.81Zm-1.37,1.38c.29-.24.45-.51.37-.6-.25-.24-.91.25-.91.67C203.89,134.49,204.09,134.46,204.43,134.19Zm-1.58.88a.75.75,0,0,0-.35.56c0,.19.16.25.35.13a.77.77,0,0,0,.35-.56C203.2,135,203,135,202.85,135.07Zm-1.73,1.73c-.28.33-.3.53-.07.53a.8.8,0,0,0,.59-.37C202,136.35,201.59,136.22,201.12,136.8Zm-1.54,2c.14.24.32.2.51-.1s.23-.52.15-.59C200,137.81,199.37,138.44,199.58,138.78Zm-.93.7a1.11,1.11,0,0,0-.61.61c-.08.26.05.39.31.31a1.14,1.14,0,0,0,.61-.61C199,139.53,198.91,139.4,198.65,139.48Zm-1.37,1.33a.35.35,0,1,0,.35.35A.35.35,0,0,0,197.28,140.81ZM185.81,290.48a5.35,5.35,0,0,0-3.73,2.43A2.57,2.57,0,0,1,180.9,294c-.7.25-.74.44-.52,2.1.13,1,.32,2.48.43,3.29.17,1.37.68,1.88,2.2,2.17a24.42,24.42,0,0,0,2.73-.93c2.24-.85,2.65-1.14,3.26-2.34a3.49,3.49,0,0,0,.3-3.17C188.76,292.72,187.09,290.48,185.81,290.48Zm-8.72-12.18c-.87-.45-1.39-1-1.39-1.36,0-1-4.06-3.46-7-4.22-3.3-.84-4.18-.52-6.67,2.44-1.89,2.26-1.9,2.28-2.09,5.12l-.19,2.85,2.42,1.46c2.1,1.28,3,1.59,7.36,2.42,2.72.53,5.13,1,5.35,1s.72-.79,1.1-1.79l1.59-4.22a23.48,23.48,0,0,0,.91-2.69C178.49,279.14,177.86,278.69,177.09,278.3ZM154,298.66l-3.07-.7-2.35-.53-2.36,1.19c-3.1,1.57-3.75,2.34-4.42,5.23-.54,2.33-.53,2.5.19,4.7,1.37,4.22,4.22,8.18,5.66,7.87.41-.09,1.73-.33,2.92-.54,2.56-.43,7.64-3.42,7.93-4.65l.8-3.52.63-2.79-2.6-3A14.89,14.89,0,0,0,154,298.66Zm-10.75-10.72c2.2-1.22,5.08-7.63,5-11.21,0-1.91-.62-2.64-3.27-4-1.23-.61-1.43-.61-3.6-.09s-2.32.59-3.19,2.3a21.13,21.13,0,0,0-1.35,3.48c-.41,1.56-.4,1.84.18,2.81a9.18,9.18,0,0,1,.88,2.71c.22,1.49.41,1.75,2.22,3C142.4,288.56,142.22,288.5,143.23,287.94Zm-25.16-9.74c-2-1.68-3.27-2.41-4.52-2.71a14.88,14.88,0,0,1-3.38-1.41l-1.66-1L104.74,275,101,276.86l-.41,3.61c-.36,3.18-.32,4.18.29,8.46.68,4.67.75,4.89,1.83,5.82a2.77,2.77,0,0,0,1.65.81c.3-.08,1.28-.25,2.19-.37a3.35,3.35,0,0,0,2.08-.85c.24-.35,2.41-2.72,4.81-5.29,6.66-7.09,7.76-8.32,7.61-8.44Zm-4.33-35.41a.34.34,0,0,0,.35-.34.35.35,0,1,0-.69,0A.34.34,0,0,0,113.74,242.79Zm-.69,4.78a20.11,20.11,0,0,0-1.67-1.74l-1.66-1.64-3.44,3.48h3.39A30.17,30.17,0,0,0,113.05,247.57Zm-1.22-4.78c.29,0,.52-.15.52-.34s-.23-.35-.52-.35-.52.16-.52.35S111.54,242.79,111.83,242.79Zm-2.26,0c.38,0,.69-.15.69-.34s-.31-.35-.69-.35-.7.16-.7.35S109.18,242.79,109.57,242.79Zm-2.26,0c.28,0,.52-.15.52-.34s-.24-.35-.52-.35-.53.16-.53.35S107,242.79,107.31,242.79Zm-1.94,0a.36.36,0,0,0,.37-.34c0-.19-.07-.35-.16-.35s-.25.16-.36.35S105.17,242.79,105.37,242.79Z" />
            <path
                className="c building-fill"
                d="M231,288.83c0,.11-4.11,2.56-9.14,5.44s-9.38,5.31-9.66,5.41c-.65.25-4.52-6.92-4-7.4.83-.74,18.34-10.5,18.58-10.35A64,64,0,0,1,231,288.83Z" />
            <path
                className="c building-fill"
                d="M356.71,229.22l-.07,17.94-.06,17.93-22.48,0c-12.36,0-23,0-23.61,0l-1.13,0v23.85c0,15.66-.12,23.84-.35,23.84s-.35,1.28-.35,3.13.15,3.13.33,3.13.26,1.1.16,2.64c-.13,2-.07,2.59.25,2.39s.32-.11.11.23a2.22,2.22,0,0,0-.2,1.27c.08.6-.07.78-.64.78-.74,0-.74-.06-.63-6.78l.1-6.79h-7.83v13.57h-9.74l-.09,29.26c-.06,21-.2,29.15-.47,28.88s-5.81-.38-18.13-.36H254.13l-.23-34.72c-.13-19.1-.23-51.37-.23-71.71v-37H239.4c-12.46,0-14.27-.07-14.27-.52s.92-.53,6.26-.53c4.13,0,6.27-.12,6.27-.36s-.63-2.86-1.39-5.9a38.31,38.31,0,0,1-1.4-7.82,12.06,12.06,0,0,1,.11-2.28c.06,0,3.82-.78,8.35-1.74l8.25-1.74h7.27c5.5,0,7.32-.1,7.44-.43s.44-2,.77-3.92l.6-3.48,4.15-6.29,4.15-6.29,12.09-.77c6.65-.42,12.57-.76,13.16-.76,1.21,0,18.2,7.44,18.81,8.23.22.28,1.85,4.38,3.62,9.11s3.68,9.82,4.25,11.3l1,2.7Z" />
            <path
                className="d border-stroke no-fill"
                d="M104.83,241.27l-2.69,1.3-2.48,4-7.91,3.69-5.42.26-5.54,3.72L75,262.46,72.07,264,69.91,269l6.72,7.69c2.44,2.93,3.56,6,4.84,9A99.19,99.19,0,0,1,79.08,298l22,18.9,2.41-5.27,4-6,1.79-.51,2,3.21.46,3.18-.92,4,2.12,3.8-.26,2.21-2.21,3.27,2.66,2.73,28.57,4.87,17.65-.18,14.33,2.58,3.77-10.09,1.09-9.9,3.13.1,3.48,1.34,2.84,5.63.54,3.89,3,3.16,4.48,9.15,56.65.74v46.64h36.55l30.92,24.95,33.58-.18,7.46-24.48,28.92-12.28,4.52-4v2.89l0,1.11-.88,2a9.39,9.39,0,0,1-2.66,2.58l-3,2.1" />
            <path
                className="d border-stroke no-fill"
                d="M114.58,241.37l3.5,1.52,3.72,5.25,11.26-.08,5.39,4.26-1.06,6.92.68,2.89,2.06,1.9,5.24-4.48,6.85-9.36,8,3.5,4.33,1.14,9.72.91,13,19.33,1.4.11,2.66-1.77.81-2.26-.6-3.22L183.33,258l17.36-18.11-.12-3.17-1.52-2.44,4.41-16,5.28-1.8.06-2.75-4.69-2.15L194,189.14l2.57-4.85,8.58-3.59,2-2.58-13-13.27.5-4,7.87-7.06-1.42-6.63-5.37-5.09,0-.47" />
            <path
                className="d border-stroke no-fill"
                d="M208,129.94l7.84,4.53,4.59,6.21,2.84.93,6.53-1.45,9.58,6.67,14.87.9,6.39-3.13,5.66-14.15,6.39-5.57,8.61,0,7-6.15,6.55.15-.31-8.7-7.21-8L283.7,99.9l.26-3.08,4.75-9.43,29.66-15.82L344.9,85.25l1.56,14,3.12,6,11.22,5L376.23,102l2.08,3.3,2.23,3L396,127.78v22l-12.77,9.39L381,155.84l-7.72-3.21h-2.43l-6,3.23-2.22,1.88-.07,1.68L364,161l2.63,0,10.47,19.09-2.32,7.47,9.81,16.22-26.58,26,.07,33.76h1.11l15,33.31-5.38,10.4,0,9.23,5.06,3,11.85-.92,10.27,15,9.57,22.25v4.36s2.36,6.6,2.68,7,.7,7,.7,7l-.74,4.58-1.7,3.83L404.84,385l-2.77,3-4,3-6.94,3.44" />
        </SVGOverlay>
    ),
    dieMaschineUnderground: (
        <SVGOverlay attributes={{ viewBox: '0 0 512 512' }} bounds={ImageBounds}>
            <defs>
                <style>
                    {globalStyle}
                    {`
                .d{stroke:#b33536;}
                .d{strokeMiterlimit:}
                .d{10;strokeWidth:0.96px;}
                `}
                </style>
            </defs>
            <rect className="a background-fill" width="512" height="512" />
            <path
                className="b field-fill"
                d="M153.5,260l1.15-.17,2.59-15.9,1.85-8.81,3-11.42,6-6.39-6.51-7.19,43.26-45,10.24-3.81,27.2-21.79,17.31,15.12-6.42,16.52c-1.69-.42-3.51-2.82-4.81-4.13L228.9,185.2h-6.46l-3.54,3.58.36,1.15,19,18.84h3.54l8.65,9.2,11.16.06L276.37,193H292v-15.6h10.84v-17.8h61.92v14h24.56v38.21H370.16v13.84l4.57,6.09v11.95l-4.51,5.79h-3.17v7.37l9.81,8.9v19.19H365.65v8.41h6.64l6.82,2.44,5.73,2.62,4,2.56,2.31,1.95,3.11-3.11,5.67,4.45,2.07,2.81.73,1.28-3.05,3c9.35,11.45,9.91,24,9.33,36.75l5.48,5.18,11.4-10.48,18.34.49L454,353.5l-33.88,34.32,4.14,3.47c-4.06,12.78,7.82,17,15.29,12.25,1.42-.91,2.69-4.08,2.79-6.78.12-2.86-.94-5.24.45-6l16,.07c1.11-.82.07,3.17-.41,6.45a36,36,0,0,1-3.14,11.16c-3.73,7.32-11.5,14.2-21.88,14.29-6.55.06-14.19-2.18-22.34-9.93l-5,5.19-8.48-8.44-2.31,2.29-.4,2.35L363.12,444l-10.87-10.82v-9.93l-3.14-3,6.26-5.83-2.54-2.64-12.93-5.16L337.42,409l-18.5-6-3.06,2.38-8.21-5.59,2.65-3.55-5.7-5.48-2.85,1.95L294.47,383l3.12-8.8-4.41-6.11-3.53-11.72,4.21-.13-.28-3.24-15.45-9.33-11.69,0,.12,4.89L261,354.17,243.82,354l-7.18-7.2h-48V319.2l-3.46-1.29-14.82.26,0-22.33-11.67-.07-3.41-3.39-.07-19.16,48.75-.06,2.69,1.39h4.93l-.07-26.18h18.18l8.74-8.48-.13-10.62-7.94-7.62c-1.35-1-.71-2.87-1-4.34l-19.49-19.1-3.71,3.71.24,6.41-23.67,22.75-6.26-6.39-10,29.55-.07,6.1-.62.83Z" />
            <path
                className="c building-fill"
                d="M156.18,259.88c-.08,0-.24.16-.36.34s0,.34.15.34a.35.35,0,0,0,.36-.34C156.33,260,156.26,259.88,156.18,259.88Zm1.85,0c-.38,0-.68.16-.68.34s.3.34.68.34.67-.15.67-.34S158.4,259.88,158,259.88Zm2.37,0c-.37,0-.68.16-.68.34s.31.34.68.34.68-.15.68-.34S160.77,259.88,160.4,259.88Zm-1.83-2.72,1.15,1.2c.64.65,1.17,1.18,1.19,1.18s.56-.53,1.19-1.18l1.15-1.2Zm3.69,3.08c-.11.17.11.32.5.32s.7-.06.7-.13C163.46,260.11,162.44,259.94,162.26,260.24Zm14,51.48c-.1-.24-.18,0-.18.42s.08.66.18.43A1.37,1.37,0,0,0,176.24,311.72Zm0-2c-.1-.23-.18,0-.18.43s.08.65.18.42A1.37,1.37,0,0,0,176.24,309.68Zm0-6.44c-.1-.24-.18-.05-.18.42s.08.66.18.42A1.34,1.34,0,0,0,176.24,303.24Zm0-2c-.1-.24-.18,0-.18.42s.08.66.18.42A1.34,1.34,0,0,0,176.24,301.2Zm0,12.92c-.11-.28-.19-.2-.2.2s.06.56.18.44A.67.67,0,0,0,176.24,314.12Zm0-6.45c-.11-.27-.19-.19-.2.2s.06.56.18.45A.69.69,0,0,0,176.24,307.67Zm0-2c-.11-.27-.19-.19-.2.21s.06.55.18.44A.68.68,0,0,0,176.24,305.63Zm0-6.45c-.11-.27-.19-.19-.2.21s.06.56.18.44A.68.68,0,0,0,176.24,299.18Zm0-2c-.11-.27-.19-.19-.2.2s.06.56.18.45A.69.69,0,0,0,176.24,297.15Zm12.67-3.33c-.51,0-.45-8.58.06-9.1.32-.31-1.85-.39-9.75-.33l-10.17.08,19.18.2v9.15h-8.49c-4.66,0-8.48.06-8.48.14,0,1,.54,1.21,2.58,1.21,1.5,0,2.18.14,2.2.43s.06.34.2,0,1.77-.43,6.59-.43c6.19,0,6.41,0,6.41-.67C189.24,294.12,189.09,293.82,188.91,293.82Zm2.28-9.37a.68.68,0,0,0-.65,0c-.27.11-.19.19.21.21S191.3,284.56,191.19,284.45Zm2,32.92a.66.66,0,0,0-.65,0c-.28.11-.2.19.2.21S193.34,317.48,193.23,317.37Zm.33-32.92a.66.66,0,0,0-.64,0c-.28.11-.19.19.2.21S193.68,284.56,193.56,284.45Zm1.7,32.92a.65.65,0,0,0-.65,0c-.27.11-.19.19.21.21S195.38,317.48,195.26,317.37Zm.52-32.94a1.37,1.37,0,0,0-.85,0c-.23.09,0,.17.42.17S196,284.52,195.78,284.43Zm1.7,32.92a1.24,1.24,0,0,0-.85,0c-.24.09,0,.17.42.17S197.71,317.44,197.48,317.35Zm.67-32.92a1.34,1.34,0,0,0-.84,0c-.24.09-.05.17.42.17S198.39,284.52,198.15,284.43Zm1.36,32.92a1.24,1.24,0,0,0-.85,0c-.23.09,0,.17.43.17S199.74,317.44,199.51,317.35Zm.84-32.9a.68.68,0,0,0-.65,0c-.27.11-.19.19.21.21S200.46,284.56,200.35,284.45Zm1.36,32.92a.65.65,0,0,0-.65,0c-.27.11-.19.19.2.21S201.82,317.48,201.71,317.37Zm.43-24.57c-.18,0-.34.23-.34.51s.16.51.34.51.34-.23.34-.51S202.33,292.8,202.14,292.8Zm-.25-8.48c-.51,0-.52.05-.09.33.64.42.68.42.68,0C202.48,284.47,202.21,284.32,201.89,284.32Zm.28,10.52c-.24,0-.27.56,0,1.27.11.36.36-.05.36-.6C202.48,295.14,202.34,294.84,202.17,294.84Zm0-4.09a.89.89,0,0,0-.15.76c.3.48.47.29.47-.49C202.47,290.42,202.4,290.36,202.16,290.75Zm.32,6.63c-.19-.12-.34-.05-.34.15a.35.35,0,0,0,.34.36c.19,0,.34-.07.34-.15S202.67,297.49,202.48,297.38Zm1.27,20a.68.68,0,0,0-.66,0c-.26.11-.18.19.21.21S203.86,317.48,203.75,317.37Zm.6-20.16c-.28,0-.51.15-.51.34s.23.34.51.34.51-.15.51-.34S204.63,297.21,204.35,297.21ZM206,317.35a1.24,1.24,0,0,0-.85,0c-.23.09,0,.17.43.17S206.19,317.44,206,317.35Zm.42-20.14c-.28,0-.5.15-.5.34s.22.34.5.34.51-.15.51-.34S206.66,297.21,206.38,297.21Zm1.78,20.16a.66.66,0,0,0-.65,0c-.27.11-.19.19.2.21S208.27,317.48,208.16,317.37Zm-.09-19.81c-.11.18.12.33.5.33s.7-.06.7-.13C209.27,297.43,208.25,297.27,208.07,297.56Zm2.13,19.81a.68.68,0,0,0-.66,0c-.27.11-.19.19.21.21S210.31,317.48,210.2,317.37Zm.85-19.71a1.37,1.37,0,0,0-.85,0c-.23.1,0,.18.42.18S211.28,297.76,211.05,297.66Zm1.36,19.69a1.24,1.24,0,0,0-.85,0c-.24.09,0,.17.42.17S212.64,317.44,212.41,317.35Zm.76-19.8a.7.7,0,0,0-.53-.34.33.33,0,0,0-.32.34c0,.19.24.34.53.34S213.29,297.74,213.17,297.55Zm-.81,33.26h-1.67l-3.93-4.16c-3.74-4-3.93-4.23-3.94-5.6,0-1.05-.14-1.44-.51-1.44s-.51.43-.51,1.83v1.83l4.11,4.28,4.11,4.27h2c1.55,0,2-.11,2-.5S213.61,330.81,212.36,330.81ZM227,317.24c-.32,0-.44-2.37-.5-10.1l-.09-10.1L220,297l-6.36-.1v21.06H220a42.23,42.23,0,0,0,6.88-.34C227.24,317.36,227.28,317.24,227,317.24Zm-1.78-.35h-5.09a26.8,26.8,0,0,1-5.13-.25c0-.14-.09-4.34-.15-9.33l-.11-9.08h10.48Zm2.2-19.68c-.28,0-.5.15-.5.34s.22.34.5.34.51-.15.51-.34S227.7,297.21,227.42,297.21Zm2,20.14a1.27,1.27,0,0,0-.86,0c-.23.09,0,.17.43.17S229.61,317.44,229.38,317.35Zm.08-19.92c-.28.1-.51.25-.51.33s.23.13.51.13.51-.15.51-.33S229.74,297.32,229.46,297.43Zm2.11,19.94a.65.65,0,0,0-.65,0c-.27.11-.19.19.21.21S231.69,317.48,231.57,317.37Zm.5-19.89c-.31-.32-.5-.32-.81,0s-.23.41.4.41S232.39,297.8,232.07,297.48Zm1-7.46-.11-2.51-1.46-.92-1.46-.93-13.87.09-13.87.09,0,1a6.9,6.9,0,0,1-.11,1.19,1.37,1.37,0,0,0,.19,1.62c.4.37.47.12.47-1.61V286h27l1.43,1.05,1.42,1.05v2.36c0,1.3.12,2.3.26,2.21A7.73,7.73,0,0,0,233.08,290Zm.53,27.35a.66.66,0,0,0-.65,0c-.27.11-.19.19.2.21S233.72,317.48,233.61,317.37Zm.5-19.89c-.32-.32-.5-.32-.82,0s-.22.41.41.41S234.43,297.8,234.11,297.48Zm1.71,19.87a1.24,1.24,0,0,0-.85,0c-.23.09,0,.17.43.17S236.05,317.44,235.82,317.35Zm.5-19.67a.68.68,0,0,0-.65,0c-.27.11-.19.19.21.2S236.44,297.8,236.32,297.68Zm1.54,19.67a1.24,1.24,0,0,0-.85,0c-.23.09,0,.17.42.17S238.09,317.44,237.86,317.35Zm.08-20.14c-.28,0-.51.15-.51.34s.23.34.51.34.51-.15.51-.34S238.22,297.21,237.94,297.21Zm2.12,20.16a.66.66,0,0,0-.65,0c-.27.11-.19.19.2.21S240.17,317.48,240.06,317.37Zm.11-20.16a.72.72,0,0,0-.53.34c-.12.19,0,.34.32.34s.53-.15.53-.34A.33.33,0,0,0,240.17,297.21Zm1.92,20.16a.65.65,0,0,0-.65,0c-.27.11-.19.19.21.21S242.2,317.48,242.09,317.37Zm.5-19.89c-.31-.32-.49-.32-.81,0s-.23.41.41.41S242.91,297.8,242.59,297.48Zm10.8-128c-.19-.12-.35,0-.35.31,0,.6.21.68.5.21A.38.38,0,0,0,253.39,169.45Zm-3.66,138-4.15-.07.07,4.84.08,4.83.1-4.65.11-4.66,4-.11,4-.1Zm4.32-140.06c-.18-.11-.33-.13-.33,0a3.47,3.47,0,0,1-.2.7c-.12.29-.05.54.13.54s.43-.23.53-.5A.6.6,0,0,0,254.05,167.4Zm.69-2.2c-.19,0-.34.32-.34.7s.15.61.34.49a.9.9,0,0,0,.34-.7C255.08,165.42,254.93,165.2,254.74,165.2Zm-.49-6.11c-.87-1.65-.85-1.66-1.71,1.19-.77,2.57-.8,2.54,1.2,1.52.74-.38,1.34-.8,1.33-.93A11.85,11.85,0,0,0,254.25,159.09Zm1.17,4.07c-.19,0-.34.32-.34.7s.15.61.34.49a.88.88,0,0,0,.34-.7C255.76,163.39,255.61,163.16,255.42,163.16Zm1-1.95c-.5.17-.78.94-.33.94.18,0,.42-.25.53-.54S256.62,161.12,256.37,161.21Zm.27-1.58c-.12.33-.05.49.2.4a.93.93,0,0,0,.54-.54C257.58,158.89,256.88,159,256.64,159.63Zm1.22-2.64c-.31-.32-.4-.23-.4.41s.09.72.4.4S258.18,157.31,257.86,157Zm.61-1.63a.34.34,0,0,0-.34.34.35.35,0,0,0,.34.34.34.34,0,0,0,.34-.34A.34.34,0,0,0,258.47,155.36Zm17.65,108.08-2.72-2.69-2.71,2.69-2.72,2.7,2.63,2.64a31,31,0,0,0,2.8,2.64,29,29,0,0,0,2.81-2.64l2.63-2.64ZM287,274l-2.71-2.7-2.72,2.7-2.71,2.7,2.62,2.64a29,29,0,0,0,2.81,2.64,31,31,0,0,0,2.8-2.64l2.63-2.64ZM290,249.19l-2.72-2.7-2.72,2.7-2.71,2.7,2.62,2.64a30.92,30.92,0,0,0,2.81,2.63,30.92,30.92,0,0,0,2.81-2.63l2.62-2.64Zm3.22-44.62c-.44,0-.51,1.28-.51,9.5s.07,9.5.51,9.5.51-1.28.51-9.5S293.7,204.57,293.26,204.57ZM290.82,303l-13-12.44,0-4.53-21.3-21.3,8.85-8.21L262.86,254l1.36-1.28-3.81-3.61-2.72,2.31-1.95-1.79-7.46.05-6.69,9.93-9,.07.17,12.62-8.33.1.07,2.73,7.08-.16,2.26-1.46h4.64l8.62,8.6,0,7.39-2.86,0-.2,3.06,2.89,2.86-.13,1.17,20,0-.13,22-19.86.07-.56,8.06-6.29,6,2.8,3,3.11-.66,5,4.21h1.36l10.09-9.21,5.09-.17,2.15,1.49h7.81l3.23-9.57,19.95-19.06Zm10.24-43.1-2.54-2.53-2.72,2.7-2.71,2.7,2.62,2.64a30.4,30.4,0,0,0,2.81,2.64,26.78,26.78,0,0,0,2.64-2.47,16.33,16.33,0,0,0,2.45-2.81A17.24,17.24,0,0,0,301.06,259.88ZM334,222.47c-.07-.79-.14-1.56-.16-1.7s-6.35-.25-14.1-.25H305.64V222c0,1.45.05,1.51,1.11,1.64.6.07,7,.16,14.24.2l13.13.06Zm11.44,174A56,56,0,0,1,336,393a61.82,61.82,0,0,1-9.06-5.72,6,6,0,0,0-2.1-1.28c-.31.31-7.53-6.87-9.94-9.87a15.44,15.44,0,0,1-2-2.84,6.49,6.49,0,0,0-1-2,43.9,43.9,0,0,1-6.14-16.5c-.52-3.1-.71-3.65-1.24-3.65s-.6.19-.4,1.61c.26,1.84,1.33,6.81,1.84,8.54a4.19,4.19,0,0,1,.26,1.24s-.87.46-1.83.95a8.39,8.39,0,0,0-2,1.2c-.16.27,2.31,4.84,5.3,9.78l.67,1.1,2-1,2-1,1.88,2.45a84.39,84.39,0,0,0,9.31,9.59c.41.29.76.68.76.87a10.51,10.51,0,0,1-1.42,2.21c-1.15,1.52-1.33,2-.94,2.17s2.4,1.65,4.73,3.33c3.29,2.37,4.32,3,4.59,2.62l1.44-2,1.09-1.57,2,1A50.23,50.23,0,0,0,346.28,398c.05,0,.09-.28.09-.65S346.07,396.59,345.43,396.45Zm6.44-168.11c-.23.36-.28.66-.11.66s.4-.25.52-.56C352.59,227.63,352.35,227.57,351.87,228.34Zm3.07,21.33-2.69,0-4.81-5.35-.05-12.4,2.33-3.62-1-.42-.05-2.3L287.48,225v4.58l-16.1.06-.13,5.07,1.59,1.75L270,239.35l3.86,4.15,2.48-2.05,1.63,1.72,8.64-7.94,20.92,21.48,5.21.68,9.9,10.59.7,13.5,9.6-8.81.89-2.94.35-1.05,9.31-9.49,11.71-2.47ZM353.56,226a5.71,5.71,0,0,1-2.76-.43c-.37-.34-.41-.34-.22,0s.08.43-.12.43-.36.3-.36.67c0,.63.23.68,2.89.68s2.88-.05,2.88-.68S355.64,226,353.56,226Zm13.86,180.26a98.72,98.72,0,0,0-9.15,8.16.26.26,0,0,0,.29.26.49.49,0,0,0,.42-.26c.06-.14,1.94-1.93,4.18-4l4.42-4C367.8,406.17,367.74,406.11,367.42,406.21Zm.87-181.62c-.07,0-.22.23-.33.51s0,.51.14.51.33-.23.33-.51S368.36,224.59,368.29,224.59ZM366.35,226c-2.45,0-2.68.05-2.68.67s.23.68,2.89.68a14.77,14.77,0,0,0,2.88-.14C369.44,226.15,368.92,226,366.35,226Zm-4.28,101.2a.55.55,0,0,0-.2.69c.14.25-.68.28-2.62.12l-2.83-.24-3.84,3.83-3.84,3.83v2.74a8.79,8.79,0,0,1-.35,3.09c-.36.36.44,1.19,7.76,8.05,2.56,2.4,3.25,2.89,3.65,2.57s.24-.67-1-2a26.84,26.84,0,0,1-2.61-3.55,8.65,8.65,0,0,1,2.73-12c2.85-1.88,7.88-1.3,10.65,1.22,3.54,3.22,3.56,3.24,4,2.83C374.13,337.79,362.68,326.65,362.07,327.15Zm3.56-137.46-13.92-.05h-2.29V176.06H352c2,0,2.54-.1,2.54-.51s-2.37-.51-19.34-.51-19.35.06-19.35.51,1.14.51,8.15.51h8.15V189H309.23l-2,1.94-2,1.94v14.54l1.89,2.15,1.89,2.16H321c6.55,0,11.83-.08,11.73-.17s-5.35-.18-11.68-.19h-11.5l-1.95-2.08-2-2.07v-14l1.79-1.76,1.79-1.77,23.4-.17,0-6.71,0-6.7h16.51v14.25h27.83v7.79l-4.33.1-4.32.11,4.49.07,4.5.08v-8.73Zm8.45,16.91c-3.42,0-6.29.07-6.37.16a4.36,4.36,0,0,0,0,1.52l.13,1.38H380.3V206.6ZM396,355.75l-.15-11c-.17-12.13-.34-13.45-2.36-18.41a29.29,29.29,0,0,0-7.33-10.5c-6.44-6.1-13.51-8.64-25.1-9l-5.88-.19.16-4.61c.09-2.54.19-5.46.23-6.49s.05-4.65,0-8.06l0-6.19h-6.17c-5.23,0-6.26-.08-6.78-.55s-.91-.27-6,4.54c-2.95,2.81-5.7,5.47-6.12,5.93a21.94,21.94,0,0,0-2.14,4.87L327,300.1l2.47,2.26c1.58,1.45,2.59,2.15,2.81,1.94s.19-.54-.06-.94,0-1,2.81-3.8c2.61-2.61,3.19-3.37,3.2-4.21a3.05,3.05,0,0,1,1.27-2.22l4.25-4.06,3-2.86,3.89,3.88c3.71,3.71,3.89,4,3.89,5.29v1.41l-3.31.41c-14.56,1.83-27.84,13.51-32.11,28.25-1.32,4.53-1.69,9-1.45,17.07.12,3.92.31,7.53.42,8,.16.71.05,1-.54,1.31-.41.22-.88.27-1,.11s-1-5.09-1.91-11L313,330.3l-2.38-2.67c-1.31-1.46-2.53-2.86-2.7-3.11-.34-.48-.28-.55,9.81-9.77l5.42-5,.78.73c.6.57.87.64,1.18.32s0-.82-1.44-2.29c-3.38-3.45-3.09-3.36-7.08-2l-3.43,1.16-5.95,5.5a64.94,64.94,0,0,0-5.85,5.78c.05.15,1.93,2.3,4.19,4.78s4.58,5.06,5.17,5.74c1.06,1.21,1.1,1.39,2.78,12.29,1.65,10.67,1.92,12.08,2.36,12.44a21,21,0,0,1,1.17,3.06,43.87,43.87,0,0,0,10,16.92,51.11,51.11,0,0,0,9.86,7.34,5.45,5.45,0,0,1,1.38.89c.39.6,4.87,2,11.18,3.46,7,1.64,12.5,2.87,13.06,2.92.2,0,4.82-4.45,10.26-9.89l9.93-9.92,1.3,1.28c1.06,1,1.39,1.19,1.69.82.56-.67-13.29-14.51-13.91-13.89-.33.33.4,1.24,3.58,4.43l4,4L377.78,367a14.91,14.91,0,0,1-2.67,1.9,22.47,22.47,0,0,1-7.87,1.22h-2.38l-1.21-1.94c-.91-1.45-3.83-4.31-11.48-11.21-8.58-7.75-10.34-9.19-10.76-8.85s-.38.52-.23.65c.79.67,14.33,12.86,17.33,15.61a32.19,32.19,0,0,1,4.36,4.67l.84,1.44h-5a30.54,30.54,0,0,1-7.9-.69,24.82,24.82,0,0,1-18.71-18.29c-.65-2.58-.7-3.51-.56-11.51.13-7.57.25-9.06.89-11.42,2.11-7.77,6.7-13.41,13.11-16.08a30.22,30.22,0,0,1,8.81-2.08h1.2v-3.13l6.36.17c7.83.2,11.17,1,17,3.84a22.71,22.71,0,0,1,6.56,4.47,29.52,29.52,0,0,1,9.66,19.37l.24,2.77h-7.38L378.77,329c-7.36-7.19-9.25-8.87-9.63-8.56s1.33,2.15,9,9.63l9.47,9.24h4.31l-.13,5.86c-.13,5.55-.18,5.93-1,7.59a20.16,20.16,0,0,1-2.54,3.53L386.56,358l-3.79-4c-3.4-3.58-4.51-4.35-4.5-3.13a88.6,88.6,0,0,0,6.78,7.19c5.37,5.37,6.86,6.69,7.19,6.36s.16-.68-.84-1.7l-1.25-1.28,2.91-2.88ZM338.25,381.7a15.87,15.87,0,0,1-2.06-1.08,38.72,38.72,0,0,1-16.12-17.19c-1.45-3-3.56-8.5-3.56-9.34,0-.23.51-.67,1.13-1l1.14-.55.43,1.93a36.22,36.22,0,0,0,18.25,24,5.4,5.4,0,0,1,1.78,1.21A4.16,4.16,0,0,1,338.25,381.7Zm17.2,4.4-5-1.18c-2.71-.64-6.25-1.57-7.87-2.07l-3-.9.49-.95.49-.94,2.07.84a58.54,58.54,0,0,0,10.92,2.7c1.94.22,1.95.23,1.95,1.37A4.16,4.16,0,0,1,355.45,386.1Zm-.6-84.07c0,2.15-.09,4.61-.21,5.48-.21,1.49-.28,1.57-1.45,1.74-11.91,1.69-19.14,8.12-22.14,19.69-.73,2.83-.79,3.73-.8,12.05,0,10.13.17,11.2,2.54,16.12,3.18,6.58,9.24,11.49,17,13.77,2.14.63,3.64.77,9.42.9l6.87.16v1.66c0,1.09.15,1.67.42,1.68s2.18,0,4.33,0l3.9,0-6.1,6.12c-3.36,3.36-6.34,6.1-6.62,6.08s-1.78-.34-3.33-.7l-2.81-.68.1-1.41.1-1.41L353.7,383c-11.15-1.1-21.7-6.88-27.9-15.29a35.56,35.56,0,0,1-6.51-16.77c-.13-1.65-.24-7-.23-11.82,0-7.92.08-9.12.74-11.75,3.89-15.41,17.82-27.89,32.42-29l2.63-.21Zm74.83,52.46c-.37.19-4.55,4.28-9.27,9.09l-8.59,8.73-1.66-1.64L408.5,369,395.6,381.9l-12.9,12.87,1.75,1.77c1.7,1.73,1.73,1.79,1.14,2.45-.34.37-5.56,5.6-11.6,11.62s-11,11.1-11,11.29,5.45-5.07,12.12-11.69,12.19-12.08,12.28-12.13a6.43,6.43,0,0,0-1.34-1.62l-1.5-1.53,12-12,12-12,1.21,1.18a7.41,7.41,0,0,0,1.41,1.19c.15,0,18.24-18,18.95-18.89C430.28,354.22,430.05,354.29,429.68,354.49Zm13.74,35.7a.35.35,0,0,0-.34.34.34.34,0,0,0,.34.34.34.34,0,0,0,.34-.34A.34.34,0,0,0,443.42,390.19Zm1.89,0a.93.93,0,0,0-.7.34c-.11.19.11.34.49.34s.7-.15.7-.34S445.58,390.19,445.31,390.19Zm2,0c-.27,0-.5.16-.5.34s.23.34.5.34.51-.15.51-.34S447.61,390.19,447.32,390.19Zm2,0c-.28,0-.51.16-.51.34s.23.34.51.34.51-.15.51-.34S449.64,390.19,449.36,390.19Zm2,0c-.28,0-.51.16-.51.34s.23.34.51.34.51-.15.51-.34S451.68,390.19,451.4,390.19Zm.14,3.11-1.37-1.15-.86.8a7.67,7.67,0,0,0-1.18,1.4c-.29.54-.09.59,2.24.59a6.71,6.71,0,0,0,2.55-.25A5.91,5.91,0,0,0,451.54,393.3Zm1.89-3.45c-.27,0-.51.16-.51.34s.24.34.51.34.51-.15.51-.34S453.72,389.85,453.43,389.85Zm2,0c-.28,0-.51.16-.51.34s.23.34.51.34.51-.15.51-.34S455.75,389.85,455.47,389.85Zm1.87,0a.34.34,0,0,0-.34.34.34.34,0,0,0,.34.34.34.34,0,0,0,.34-.34A.35.35,0,0,0,457.34,389.85Z" />
            <path
                className="a background-fill"
                d="M290.82,303l-13-12.44,0-4.53-21.3-21.3,8.85-8.21L262.86,254l1.36-1.28-3.81-3.61-2.72,2.31-1.95-1.79-7.46.05-6.69,9.93-9,.07.17,12.62-8.33.1.07,2.73,7.08-.16,2.26-1.46h4.64l8.62,8.6,0,7.39-2.86,0-.2,3.06,2.89,2.86-.13,1.17,20,0-.13,22-19.86.07-.56,8.06-6.29,6,2.8,3,3.11-.66,5,4.21h1.36l10.09-9.21,5.09-.17,2.15,1.49h7.81l3.23-9.57,19.95-19.06Zm64.12-53.31-2.69,0-4.81-5.35-.05-12.4,2.33-3.62-1-.42-.05-2.3L287.48,225v4.58l-16.1.06-.13,5.07,1.59,1.75L270,239.35l3.86,4.15,2.48-2.05,1.63,1.72,8.64-7.94,20.92,21.48,5.21.68,9.9,10.59.7,13.5,9.6-8.81.89-2.94.35-1.05,9.31-9.49,11.71-2.47Z" />
            <path
                className="d border-stroke no-fill"
                d="M253.19,171.17c-1.69-.42-3.51-2.82-4.81-4.13L228.9,185.2h-6.46l-3.54,3.58.36,1.15,19,18.84h3.54l8.65,9.2,11.16.06L276.37,193H292v-15.6h10.84v-17.8h61.92v14h24.56v38.21H370.16v13.84l4.57,6.09v11.95l-4.51,5.79h-3.17v7.37l9.81,8.9v19.19H365.65v8.41h6.64l6.82,2.44,5.73,2.62,4,2.56,2.31,1.95,3.11-3.11,5.67,4.45,2.07,2.81.73,1.28-3.05,3c9.35,11.45,9.91,24,9.33,36.75l5.48,5.18,11.4-10.48,18.34.49L454,353.5l-33.88,34.32,4.14,3.47c-4.06,12.78,7.82,17,15.29,12.25,1.42-.91,2.69-4.08,2.79-6.78.12-2.86-.94-5.24.45-6" />
            <path
                className="d border-stroke no-fill"
                d="M153.5,260l1.15-.17,2.59-15.9,1.85-8.81,3-11.42,6-6.39-6.51-7.19,43.26-45,10.24-3.81,27.2-21.79,17.31,15.12" />
            <path
                className="d border-stroke no-fill"
                d="M458.72,390.81c1.11-.82.07,3.17-.41,6.45a36,36,0,0,1-3.14,11.16c-3.73,7.32-11.5,14.2-21.88,14.29-6.55.06-14.19-2.18-22.34-9.93l-5,5.19-8.48-8.44-2.31,2.29-.4,2.35L363.12,444l-10.87-10.82v-9.93l-3.14-3,6.26-5.83-2.54-2.64-12.93-5.16L337.42,409l-18.5-6-3.06,2.38-8.21-5.59,2.65-3.55-5.7-5.48-2.85,1.95L294.47,383l3.12-8.8-4.41-6.11-3.53-11.72,4.21-.13-.28-3.24-15.45-9.33-11.69,0,.12,4.89L261,354.17,243.82,354l-7.18-7.2h-48V319.2l-3.46-1.29-14.82.26,0-22.33-11.67-.07-3.41-3.39-.07-19.16,48.75-.06,2.69,1.39h4.93l-.07-26.18h18.18l8.74-8.48-.13-10.62-7.94-7.62c-1.35-1-.71-2.87-1-4.34l-19.49-19.1-3.71,3.71.24,6.41-23.67,22.75-6.26-6.39-10,29.55-.07,6.1-.62.83" />
            <polygon
                className="d border-stroke no-fill"
                points="300.45 302.88 280.5 321.94 277.27 331.51 269.46 331.52 267.31 330.03 262.22 330.2 252.13 339.41 250.77 339.41 245.79 335.2 242.68 335.86 239.88 332.82 246.17 326.81 246.73 318.75 266.59 318.68 266.72 296.69 246.77 296.65 246.9 295.48 244.01 292.62 244.21 289.56 247.07 289.53 247.1 282.14 238.48 273.54 233.84 273.54 231.58 275 224.5 275.17 224.43 272.43 232.75 272.33 232.59 259.71 241.59 259.64 248.28 249.71 255.74 249.66 257.69 251.45 260.41 249.14 264.22 252.75 262.86 254.03 265.39 256.5 256.55 264.71 277.85 286.01 277.82 290.54 290.82 302.98 300.45 302.88" />
            <polygon
                className="d border-stroke no-fill"
                points="355.22 256.72 343.51 259.19 334.2 268.68 333.85 269.73 332.96 272.67 323.36 281.49 322.66 267.98 312.76 257.39 307.55 256.71 286.63 235.23 277.99 243.17 276.36 241.45 273.88 243.5 270.02 239.35 272.84 236.47 271.25 234.72 271.38 229.65 287.48 229.59 287.48 225.01 348.69 225.62 348.74 227.92 349.72 228.34 347.39 231.96 347.44 244.35 352.25 249.71 354.94 249.67 355.22 256.72" />
            <path
                className="d border-stroke no-fill"
                d="M299.48,303.81l3.74-2.93V289.44l6.6-6.33,11.46-.07,2.08-1.6" />
        </SVGOverlay>
    ),
    firebaseZ: (
        <SVGOverlay attributes={{ viewBox: '0 0 512 512' }} bounds={ImageBounds}>
            <defs>
                <style>
                    {globalStyle}
                    {`
            .d,.e{strokeMiterlimit:11.34;}
            .d{strokeWidth:0.32px;}
            .e{strokeWidth:0.96px;}
            `}
                </style>
            </defs>
            <rect className="a background-fill" width="512" height="512" />
            <path className="b field-fill" d="M299.53,345.85l0,5.12.21,4" />
            <path
                className="b field-fill"
                d="M366.91,394.43l-4.3,17.8,8.85,8.64,3.06,5.11.92,7.52-8.2,7.78-21.66-20.41,2.22-22.65-2.44-3.16-18.3-.17-1.46,1.81,1.48,7.27-.31,30.43-9.19,5.21-.87,8.2-14.19.67-6.67-14.74.22-8.59,16.82-14.21v-2.38L301.4,391l-1.64-34.72H263.41l.21-22.15-1.14-1.44L254.37,329l-8.93-7.9,3.22-2.71.55-1.54-1.46-1.73-4.73,4.7-3.69-.88-7.88-.1.26-11.5-7.79.21-.12-1.43-23,.09V275.79H173.22L164.84,277l-.07,2.64-1.21,3.28.07,6.65.61.23,2.2-1.2,7.08,11.08-11,6.91-8.06-13.14-9.77,1-.29,8.05-12.56-.14v-7.91l-7.28-.07-5.59,8.52-16.82,10L90.5,322.72l-27.6,12-8.4-5.14.37-13.12L65.63,307l11.76-5,6.09-5,6.69-6.62L92,282.09l-4.89-3.42-9.43,0-10,8.7-12.28,1.71-12.24-9.24,3-16.54,14.21-6.35,34.43-.11,5-3.79,4.74-6.88-6.86-13.29-5.5-2-24.6-.09-25.68-9.54-4.27-9.53L42,203.09l8.62,1.78,8.86-.22,19.31,9.76,15.61-13.52-.61-7.59L84,181.59l-5.65-3.22-6.2-2.09-9.87-.1-8.92-8.11-2.09-8.27,8.5-8.08,18.47,3.43L92,160l15.23,15.48,6.08.61,15.27,8.79,15.25-.1.28,8.47,7,.38.37-.6-.77-11.07,13.1-1.42.06,13.85,2.9,15.89,2.43,1.27.68.35h.62v-.73l0-32,29.07-.2h1.75l.06-19.41,36.78-35.26h0l-.11-31.67H264.5V77.34h50V85.2h4.94V78.93H356.7V63.53h34.89c3.82-.3,20.26,4.49,24.66,11.29,11.49.48,19.23,2.07,20,5.7h2.34l1.61,4.83,4.06-1.63,7.05-.06,2.09.86L455,82,456,78.8l-.09-3.47h5.61l4.31,5.81,2.69,9.8L469,99l-7.86-.13L452.51,94l-4.91,5.15-9.73,0-3.37,6,.32,3,2.79,2.6,8.5,3.49,16.93-.25,11.27,1.28.09,5.29-2.62,7.94L463,131.47l-20.78-.18-4.83,2.78,2.39,4.26-.14,2.51.81,1.22,2.28.28,2,2.89,1,.57,4.52-4.43,17.64-.23,1.36,17.09-5.62.06-4.67,5-3.14-1.06-7.81,10.59h-6.8l-11.42,7.33H418.92l-3.73-3.43h-8.28l-10.63-5.25L390,170.21l-6.15,2.13v10.17h5.67v85.88H375.44v3.89l-4.6,5.52,5.69,4.69-5.95,6.67.08,1.51,6.12,18.42.09,2.18L370,332.73l6.32,9.33-1.08,6.76,0,2.46,21.09,16.55,1.87,7.11-2.55,2.85L402.8,386l7.76,5.31,3.7-2,6.05,4.07L418,406l-.87,1.73-5,1.31-5.5.58-3.69-.5-3.58-1.29-3.76-2.24-5.27-3.77-4.2-5.63-4.48-6.53-1.32-3.33,0,1.16Z" />
            <path
                className="c building-fill"
                d="M127.75,220.33V227H138v-6.68Zm9.79,6.23h-9.35v-5.79h9.35Z" />
            <path
                className="c building-fill"
                d="M138.78,194.63a11.9,11.9,0,0,1,2.67,0c.67.1,0,.19-1.46.18S138,194.73,138.78,194.63Z" />
            <path
                className="c building-fill"
                d="M145.91,265.64l-.13-3.21-1.67.05-3.67.09-2,.05v2.82a10.07,10.07,0,0,0,.3,3.12,14.41,14.41,0,0,0,3.8.3H146Zm-.8,2.33h-5.79v-4.9h5.79Z" />
            <path
                className="c building-fill"
                d="M138.43,251.49h4c2.37,0,4,.18,4,.45s-1.71.44-4.23.44H138V235.91l4.56.09,4.57.1-4.34.14-4.35.15Z" />
            <path
                className="c building-fill"
                d="M151.58,250.38,151.33,280h-16v-8h-18.7V254.16H130V232.79h-1.34c-.83,0-1.3-.21-1.22-.55s-1.27-.59-5.35-.68l-5.45-.13v-18.2l5.45-.12,5.46-.13-.07-2.34-.07-2.33h15.94v6.23h8l.13,11c.12,10.48.13,10.31.23-3.63l.1-14.65-6.08.29c-3.34.16-9,.29-12.47.29h-6.38v4.45H116.62v-8l3.21-4.69L123,195h2.76c1.82,0,2.81-.19,2.91-.56a29.49,29.49,0,0,0-.09-4.34l-.25-3.78-.08,3.89-.09,3.9H123l-3.62,5.22-3.62,5.22V285L119.6,289a29.25,29.25,0,0,0,4.32,3.95c.26,0-1.28-1.76-3.41-3.91l-3.89-3.9V279c0-6,0-6.12,1-6.18.55,0,2.85-.09,5.12-.12l4.12,0v8.24h24.93l-.11-15.25Zm-7.36-42.07h7.13v5.78h-7.13Zm-27.6,24h5.12c3.12,0,5.12.17,5.12.44s.6.45,1.33.45h1.34v20.48H116.62ZM134.87,280h-7.12v-7.13h7.12Z" />
            <path
                className="c building-fill"
                d="M174.05,271.75c0,2.27-.3,2.89-1,2.15a6.63,6.63,0,0,1-.29-2.45c0-1.61.16-2.15.66-2.15S174.05,269.87,174.05,271.75Z" />
            <path
                className="c building-fill"
                d="M174.05,227.58c0,2.3-.06,2.4-2.89,5.21l-2.9,2.87v17.05L174,257.5v2.56c0,2-.15,2.56-.67,2.56s-.67-.57-.69-2.33c0-2.32-.05-2.36-2.89-4.76l-2.87-2.42V235.57l2.89-3.12c2.69-2.91,2.9-3.27,2.9-5.18,0-1.52.17-2.05.66-2.05S174.05,225.78,174.05,227.58Z" />
            <path
                className="c building-fill"
                d="M183.29,213.76c-.12.38-1.58.6-4.71.68l-4.53.13v2c0,1.47-.17,2-.67,2s-.66-.49-.67-1.67a13.5,13.5,0,0,0-.27-2.67c-.27-1-.27-1,5.38-1C182.15,213.2,183.43,213.33,183.29,213.76Z" />
            <path
                className="c building-fill"
                d="M196.76,272.64c0,.86-.2,1.56-.45,1.56-.52,0-.54-.05-.61-1.78,0-.8.17-1.34.5-1.34S196.76,271.69,196.76,272.64Z" />
            <ellipse
                className="c building-fill"
                cx="203.44"
                cy="273.98"
                rx="0.89"
                ry="0.67" />
            <path
                className="c building-fill"
                d="M203,168.46c0-.48.49-.67,1.77-.67s1.71.14,1.51.67-.83.67-1.77.67S203,168.92,203,168.46Z" />
            <path
                className="c building-fill"
                d="M205.66,190.32c-3.55,0-5-.07-3.23-.15s4.68-.09,6.46,0S209.21,190.32,205.66,190.32Z" />
            <ellipse
                className="c building-fill"
                cx="207.22"
                cy="184.49"
                rx="4.23"
                ry="0.67" />
            <ellipse
                className="c building-fill"
                cx="211.45"
                cy="207.19"
                rx="0.45"
                ry="0.67" />
            <ellipse
                className="c building-fill"
                cx="211.45"
                cy="201.41"
                rx="0.45"
                ry="0.67" />
            <ellipse
                className="c building-fill"
                cx="211.45"
                cy="195.62"
                rx="0.45"
                ry="0.67" />
            <path
                className="c building-fill"
                d="M196.24,214.44c-4.21-.09-5.92-.28-6.05-.68s2.11-.56,10.28-.56c8,0,10.51-.13,10.66-.55.34-1,.87,0,.55,1s-.63.93-4.43.93h-4.13l0,2.07c0,1.3-.16,2.15-.5,2.27s-.56-.46-.56-2.07v-2.24Z" />
            <ellipse
                className="c building-fill"
                cx="211.45"
                cy="210.09"
                rx="0.45"
                ry="0.89" />
            <ellipse
                className="c building-fill"
                cx="211.45"
                cy="204.3"
                rx="0.45"
                ry="0.89" />
            <ellipse
                className="c building-fill"
                cx="211.45"
                cy="198.51"
                rx="0.45"
                ry="0.89" />
            <ellipse
                className="c building-fill"
                cx="211.45"
                cy="192.72"
                rx="0.45"
                ry="0.89" />
            <path
                className="c building-fill"
                d="M196.76,258.17v3.12c0,3.32-.87,4.47-.93,1.22,0-1-.07-2.69-.11-3.67l-.08-1.78,3.25-.13c2.21-.1,3.22-.3,3.17-.67s0-7.3,0-15.56c0-12.35.16-15,.66-15s.61,1.16.62,5.45c0,7.29,0,6.94,1.07,7.1,1.4.2,1.59,1.25.23,1.25-1.21,0-1.63,1-1.44,3.34.06.74.14,3.69.17,6.57l.08,5.23h4.15a24.63,24.63,0,0,1,4.37.21,4.41,4.41,0,0,1,0,1.78l-.18,1.57Z" />
            <path
                className="c building-fill"
                d="M215.31,286.89a15.16,15.16,0,0,1-.12,2.78c-.16.84-.49,1-2,1h-1.77v-5.84l1.89.14C215.22,285.11,215.23,285.12,215.31,286.89Z" />
            <path
                className="c building-fill"
                d="M226.06,303.73a.55.55,0,0,1-.55.74c-.41,0-.7-.38-.7-.92C224.81,302.46,225.85,302.61,226.06,303.73Z" />
            <path
                className="c building-fill"
                d="M238.06,236.91l-.12-6.12h-7.57l-.12,6.12-.13,6.12h8.07Zm-.79,5.68H231V231.46h6.23Z" />
            <path
                className="c building-fill"
                d="M239.18,305.93c1,.09.07.17-2.13.16s-3.05-.07-1.88-.17A31.48,31.48,0,0,1,239.18,305.93Z" />
            <path
                className="c building-fill"
                d="M230.15,195v8h11.57v-8Zm11.13,7.57H231V195.4h10.24Z" />
            <path
                className="c building-fill"
                d="M244.4,268.59c0,.41-.32.55-.89.39-.85-.22-.89,0-.89,4,0,2.32-.14,8.45-.3,13.63L242,296l-2.71-.08-2.72-.08,2.34-.17a4.88,4.88,0,0,0,2.35-.47c0-.17.06-2.71.11-5.65l.09-5.34-2.55-.14c-3.27-.17-3.35-1-.11-1h2.45V268h1.56C243.88,268,244.4,268.17,244.4,268.59Z" />
            <path
                className="c building-fill"
                d="M252.88,277.93c1.46,3,2.65,5.63,2.65,5.78a11.16,11.16,0,0,1-2.7,1.63l-2.69,1.36-2.65-5.61c-1.46-3.09-2.65-5.69-2.65-5.8a26.23,26.23,0,0,1,4.59-2.53C250.12,272.48,250.63,273.23,252.88,277.93Z" />
            <ellipse
                className="c building-fill"
                cx="254.41"
                cy="124.83"
                rx="8.24"
                ry="0.67" />
            <path
                className="c building-fill"
                d="M260.24,169.13H256.5l-9.84-10,.15-2.45c.08-1.35.17-5.9.2-10.13l.06-7.68H250c1.64,0,2.89-.19,2.89-.44S251.6,138,250,138h-2.89v-5.79c0-4.84-.11-5.78-.67-5.78s-.67.81-.67,4.67c0,4.16-.08,4.68-.78,4.68-.43,0-5.39,4.65-11,10.35C216.65,163.53,215,165.31,215,166.62c0,.95-.2,1.17-1.11,1.17-.7,0-1.11.26-1.11.67s.41.67,1.11.67H215v9.35h3.11v59.66h-4.22c-3.46,0-4.22.12-4.22.66s.76.67,4.23.67h4.23v18.7h6.68v15.14h-7.13c-6,0-7.12.1-7.12.67s1.09.66,7.12.66h7.13v11.61c0,9.1.12,11.58.55,11.43s.59-2,.68-6.93l.12-6.76h3.33c1.92,0,3.33-.18,3.33-.44s-1.41-.45-3.34-.45h-3.34V255.94h15.14v6.24h1.56c1.08,0,1.56-.2,1.56-.67s-.4-.67-.89-.67c-.79,0-.89-.3-.89-2.45v-2.45H246c2.51,0,3.33-.14,3.19-.55s-3.62-.59-15-.67l-14.77-.12V186.09l2.66-5.69,2.66-5.71,3.54-2c1.94-1.11,3.68-2.14,3.85-2.31s-.34-1.44-1.13-2.81a9.93,9.93,0,0,1-1.26-2.68c.1-.09,3.77-1.18,8.17-2.42l8-2.25,10.27,10.24h3.89c3.16,0,3.89-.12,3.89-.66S263.27,169.13,260.24,169.13Zm-14.61-21.08-.12,11-8.68,2.41c-4.78,1.33-8.77,2.49-8.88,2.58s.36,1.23,2.23,4.38l.81,1.35-3.61,2-3.61,2-2.14,4.64-2.15,4.65v-6h-3.11V165.71l13.91-14.21c7.65-7.81,14.27-14.27,14.7-14.35C245.7,137,245.74,137.7,245.63,148.05Z" />
            <ellipse
                className="c building-fill"
                cx="263.76"
                cy="272.86"
                rx="0.67"
                ry="2.23" />
            <ellipse
                className="c building-fill"
                cx="263.76"
                cy="286.44"
                rx="0.67"
                ry="2.45" />
            <path
                className="c building-fill"
                d="M265,198c-.92-.26-1.45-.7-1.45-1.18a65.63,65.63,0,0,1,1.5-8.42,6.84,6.84,0,0,1,2.26.35c1.8.45,2.06.66,1.87,1.47-.13.51-.47,2.59-.78,4.61C267.79,198.81,267.78,198.82,265,198Z" />
            <path
                className="c building-fill"
                d="M243,218.73,238.77,212l.88-1.83a4.32,4.32,0,0,1,1.81-2.07c1.92-.51,5.51-.24,9.52.72l4.14,1,1,3.27c.85,2.81,1.1,3.23,1.87,3,.49-.12,2.15-.35,3.68-.52l2.78-.31-.21,1.29a79.11,79.11,0,0,0-1,7.94c.07.05,1.45.7,3.07,1.45,2.91,1.34,2.93,1.37,3.22,3.47a33.07,33.07,0,0,1,.29,3.62c0,.82-.15,1.48-.33,1.46-1.14-.11-21.16-7.91-21.67-8.44C247.42,225.74,245.26,222.42,243,218.73Z" />
            <path
                className="c building-fill"
                d="M270.66,300.24c0,.55-.71.67-3.78.67h-3.79v-2c0-1.48.18-2,.67-2s.67.45.67,1.34v1.34h3.12C270,299.58,270.66,299.71,270.66,300.24Z" />
            <ellipse
                className="c building-fill"
                cx="279.79"
                cy="81.2"
                rx="0.67"
                ry="2" />
            <path
                className="c building-fill"
                d="M270.22,124.83c0-.55.79-.67,4.45-.67h4.45V106.8c0-15.14.09-17.37.67-17.37s.67,2.31.67,18v18h-5.12C271.08,125.5,270.22,125.38,270.22,124.83Z" />
            <path
                className="c building-fill"
                d="M280.46,138.85H269.7c-5.92,0-10.66-.1-10.54-.22.32-.31,21.22-.45,21.53-.14a15.46,15.46,0,0,1,.1,3.76l-.15,3.5Z" />
            <path
                className="c building-fill"
                d="M297.23,115.14a1.79,1.79,0,0,1,0,1.12c-.13.31-.23,0-.23-.56S297.1,114.84,297.23,115.14Z" />
            <path
                className="c building-fill"
                d="M297.71,348a40.59,40.59,0,0,1,0,4.68c-.09,1.28-.17.23-.17-2.34S297.62,346.71,297.71,348Z" />
            <path
                className="c building-fill"
                d="M302.79,115.7c0-.61.1-.86.22-.56a1.66,1.66,0,0,1,0,1.12C302.89,116.57,302.79,116.31,302.79,115.7Z" />
            <path
                className="c building-fill"
                d="M290.29,164.44c-.54-.52-.36-1,1.28-3.08l1.9-2.46,1.4,1c2.24,1.57,8,5.79,8.43,6.13.19.17-.49,1.39-1.52,2.72s-2,2.54-2.14,2.72S292.27,166.37,290.29,164.44Z" />
            <path
                className="c building-fill"
                d="M312.87,129.17c-.12-3.61-.2-3.91-1.1-4-.52-.08-2.69-1.93-4.8-4.12l-3.84-4h-6.07l-3.67,4c-3.24,3.55-3.83,4-5.18,4h-1.52V112.58h5.09c3.64,0,5.14.16,5.3.56.25.62.45-3.59.53-10.93,0-2.65-.12-4.91-.32-5s-.36,3.1-.36,7.15v7.37H286.69V94.33h2.78c1.87,0,2.57-.14,2.14-.41-.69-.44-3.74-.55-5-.18-.73.2-.78,1.51-.78,19.33v19.11h-5.56c-4.65,0-5.57.12-5.57.67s.92.67,5.57.67h5.56v12l6.12-.1,6.12-.09-5.67-.14-5.68-.14V133.51h1.64c1.43,0,2.06.41,5.07,3.34l3.43,3.34h6.58l3.85-3.56c2.3-2.14,4.22-3.57,4.79-3.57C313,133.06,313,132.89,312.87,129.17Zm-1.73,2.56a27,27,0,0,0-4.33,3.56L303,138.85h-5.7l-3.39-3.31c-2.92-2.83-3.65-3.32-5.19-3.45l-1.78-.14v-5.79l1.88-.13c1.72-.13,2.14-.44,5.28-3.9l3.42-3.76h5.11l3.93,4c2.16,2.2,4.19,4,4.51,4s.58.76.58,2.67C311.62,130.69,311.44,131.73,311.14,131.73Z" />
            <path
                className="c building-fill"
                d="M317,352.73c-.39.49-.38.68.06.84s.45.33.3.5-.51,0-.81-.37c-.58-.7-.3-1.59.5-1.59C317.36,352.11,317.34,352.32,317,352.73Z" />
            <path
                className="c building-fill"
                d="M318.66,349.65c.14.14,0,.5-.3.8s-.49.38-.25-.25C318.28,349.76,318.52,349.52,318.66,349.65Z" />
            <path
                className="c building-fill"
                d="M320.32,348.07a1,1,0,0,1-.76.48c-.3,0-.27-.25.09-.68C320.26,347.13,320.8,347.3,320.32,348.07Z" />
            <path
                className="c building-fill"
                d="M321.2,357c-.16-.25-.08-.45.16-.45a1,1,0,0,1,.73.45c.15.24.07.44-.17.44A1,1,0,0,1,321.2,357Z" />
            <path
                className="c building-fill"
                d="M321,346c0-.54.85-1.17,1.16-.86.11.11-.11.46-.48.77S321,346.25,321,346Z" />
            <path
                className="c building-fill"
                d="M323.42,358.2c-.37,0-.67-.17-.67-.38s.3-.37.67-.37.67.17.67.37S323.79,358.2,323.42,358.2Z" />
            <path
                className="c building-fill"
                d="M323.09,141.23a1.76,1.76,0,0,1,1.11,0c.31.12.06.22-.56.22S322.78,141.35,323.09,141.23Z" />
            <path
                className="c building-fill"
                d="M308.73,353.36c-4.16-3.44-7.65-6.48-7.75-6.73-.22-.61.63.05,8.7,6.71l6.62,5.46,1.21-1.45c.67-.8,1.13-1.7,1-2s0-.56.31-.56a2.58,2.58,0,0,0,1.29-.71c.72-.65.93-.59,2.8.78a8.16,8.16,0,0,1,2,1.85c0,.2-.88-.28-2-1.08l-2-1.44-1.67,1.95L317,358.85C316.35,359.56,315.75,359.16,308.73,353.36Z" />
            <path
                className="c building-fill"
                d="M326.61,116.93a1.76,1.76,0,0,1,0,1.11c-.13.31-.22,0-.22-.56S326.48,116.62,326.61,116.93Z" />
            <path
                className="c building-fill"
                d="M326.61,114.92c-.13.31-.22.06-.22-.55s.09-.87.22-.56A1.76,1.76,0,0,1,326.61,114.92Z" />
            <path
                className="c building-fill"
                d="M326.61,112.25c-.13.31-.22,0-.22-.56s.09-.86.22-.55A1.76,1.76,0,0,1,326.61,112.25Z" />
            <path
                className="c building-fill"
                d="M326.32,109.27c0-.38.2-.69.44-.69a.43.43,0,0,1,.45.42.94.94,0,0,1-.45.69C326.52,109.84,326.32,109.66,326.32,109.27Z" />
            <path
                className="c building-fill"
                d="M325.65,357.9c-.15-.25.14-.45.64-.45s.92.2.92.45-.29.44-.65.44A1.18,1.18,0,0,1,325.65,357.9Z" />
            <path
                className="c building-fill"
                d="M326.23,141.22a.9.9,0,0,1,.86,0c.14.14-.12.25-.59.23S325.87,141.36,326.23,141.22Z" />
            <ellipse
                className="c building-fill"
                cx="329.21"
                cy="357.9"
                rx="0.67"
                ry="0.45" />
            <path
                className="c building-fill"
                d="M329,109.05a1,1,0,0,1,.44-.69c.25-.16.45,0,.45.41s-.2.7-.45.7A.43.43,0,0,1,329,109.05Z" />
            <path
                className="c building-fill"
                d="M329.73,105.82a.9.9,0,0,1,0,.86c-.15.14-.25-.12-.23-.59S329.59,105.47,329.73,105.82Z" />
            <path
                className="c building-fill"
                d="M329.7,104c-.15.14-.25-.12-.23-.59s.12-.63.26-.27A.9.9,0,0,1,329.7,104Z" />
            <path
                className="c building-fill"
                d="M329.7,101.33c-.15.15-.25-.11-.23-.58s.12-.63.26-.27A.88.88,0,0,1,329.7,101.33Z" />
            <path
                className="c building-fill"
                d="M329.7,98.66c-.15.15-.25-.11-.23-.58s.12-.63.26-.27A.88.88,0,0,1,329.7,98.66Z" />
            <path
                className="c building-fill"
                d="M328.9,141.22a.9.9,0,0,1,.86,0c.14.14-.12.25-.59.23S328.55,141.36,328.9,141.22Z" />
            <path
                className="c building-fill"
                d="M329.43,95.69a1,1,0,0,1,.44-.69c.26-.15.33,0,.18.42C329.75,96.19,329.43,96.33,329.43,95.69Z" />
            <path
                className="c building-fill"
                d="M313.52,365.66c10.3,1.66,13.54,1,16.39-3.27a8,8,0,0,0,1.3-2.79c0-.45.22-.81.48-.81.59,0,.16,1.52-.94,3.34a11.37,11.37,0,0,1-5,4.43c-1.75.73-4.61.81-7.91.22a29.77,29.77,0,0,0-3.9-.39c-1,0-1.89-.24-1.89-.5S312.66,365.52,313.52,365.66Z" />
            <path
                className="c building-fill"
                d="M331.21,94c0-.54.85-1.17,1.16-.86.11.11-.11.46-.48.77S331.21,94.26,331.21,94Z" />
            <path
                className="c building-fill"
                d="M330.81,320.21c-2.2-1.88-4.05-5.52-4-7.92a16.59,16.59,0,0,1,.88-4.26c1.12-3.18,1.09-3.78-.09-1.55a13,13,0,0,0-1.15,5c-.18,2.85-.08,3.4,1,5.49A14.23,14.23,0,0,0,330,320.3l1.27,1.07-1.17,2c-1.4,2.38-1.82,2.29-4.62-1-3.42-4-4.33-7.06-3.6-12.17a17.88,17.88,0,0,1,2.18-6.45l1.7-3.17-2.43-1.88a12.13,12.13,0,0,0-2.58-1.74c-.08.07-1.38,3.44-2.9,7.49l-2.75,7.34,2.16,6.61,2.16,6.6,4,2.81c2.21,1.55,4,2.78,4.08,2.74s1.19-2,2.56-4.47l2.5-4.4Zm-3.29,7.91c-.49.65-.9.49-3.76-1.52l-3.21-2.24-2.07-6.21L316.42,312l2.37-6.42c1.31-3.52,2.57-6.41,2.81-6.41a3.49,3.49,0,0,1,1.4.91l1,.92-1.57,3.16c-1.43,2.85-1.6,3.59-1.78,7.75-.19,4.34-.14,4.74,1,7.13a22.83,22.83,0,0,0,3.84,5.09C328.27,326.83,328.36,327,327.52,328.12Z" />
            <path
                className="c building-fill"
                d="M332.66,141.23c.31.12,0,.22-.56.22s-.86-.1-.55-.22A1.76,1.76,0,0,1,332.66,141.23Z" />
            <ellipse
                className="c building-fill"
                cx="332.1"
                cy="357.9"
                rx="0.89"
                ry="0.45" />
            <ellipse
                className="c building-fill"
                cx="333.66"
                cy="92.1"
                rx="0.67"
                ry="0.45" />
            <path
                className="c building-fill"
                d="M334.53,346.81a9.86,9.86,0,0,1-2.65.38c-1,0-1.54.19-1.25.38a.64.64,0,0,1,.19.89c-.24.4-1.31-.2-3.75-2.12a42.72,42.72,0,0,0-3.61-2.69c-.64,0-2.38-2.12-2.11-2.57s1.46.37,3.73,2.14c3.18,2.48,3.56,2.66,5.77,2.66a18.78,18.78,0,0,1,3.46.3C335.31,346.45,335.33,346.5,334.53,346.81Z" />
            <path
                className="c building-fill"
                d="M302.85,105.24l.07-8.46.27,14.91h9.14l0-4.78c.09-9.49.12-9.91.7-9.91.42,0,.53,1.36.47,5.57l-.08,5.56h8l0,16.59c0,9.12,0,19.94,0,24l0,7.46h7.37c6.25,0,7.36.1,7.36.66s-1.19.67-8,.67h-8V164c0,5.44-.1,6.45-.67,6.45s-.66-1.11-.66-7.34v-7.35H313V145.56l-10-.28,5.23-.1,5.23-.09v9.79h6.68v-42.3h-8.42c-6.32,0-8.48.14-8.65.56A64.8,64.8,0,0,1,302.85,105.24Z" />
            <ellipse
                className="c building-fill"
                cx="335"
                cy="357.9"
                rx="0.67"
                ry="0.45" />
            <path
                className="c building-fill"
                d="M332.27,138l3,3.23v3a10.67,10.67,0,0,1-.22,3,9.53,9.53,0,0,1-.23-2.88v-2.89l-2.95-3.13c-1.63-1.73-2.86-3.24-2.73-3.37S330.65,136.26,332.27,138Z" />
            <path
                className="c building-fill"
                d="M335.73,92.13c.19-.58.8-.68.86-.15,0,.18-.21.41-.5.5S335.63,92.42,335.73,92.13Z" />
            <ellipse
                className="c building-fill"
                cx="336.56"
                cy="89.66"
                rx="0.45"
                ry="0.67" />
            <path
                className="c building-fill"
                d="M336.11,87.21c0-.25.31-.45.69-.45s.57.2.42.45a1,1,0,0,1-.69.44A.43.43,0,0,1,336.11,87.21Z" />
            <path
                className="c building-fill"
                d="M337.45,346.7c-.62,0-.87-.1-.56-.23a1.76,1.76,0,0,1,1.11,0C338.31,346.59,338.06,346.7,337.45,346.7Z" />
            <path
                className="c building-fill"
                d="M337.36,357.81c.41-.41.65-.41,1.07,0s.29.53-.54.53S336.94,358.22,337.36,357.81Z" />
            <path
                className="c building-fill"
                d="M338.7,86.9a.91.91,0,0,1,.85,0c.15.15-.11.25-.58.23S338.34,87.05,338.7,86.9Z" />
            <path
                className="c building-fill"
                d="M340.89,346.5c.14.15-.12.25-.59.23s-.62-.12-.27-.26A.9.9,0,0,1,340.89,346.5Z" />
            <path
                className="c building-fill"
                d="M340.48,358a.88.88,0,0,1,.85,0c.15.14-.11.25-.58.23S340.12,358.18,340.48,358Z" />
            <path
                className="c building-fill"
                d="M341.37,86.9a.9.9,0,0,1,.85,0c.15.15-.11.25-.58.23S341,87.05,341.37,86.9Z" />
            <path
                className="c building-fill"
                d="M328.76,210.53c-9.05,0-14-.15-14-.44s4.75-.45,13.36-.45h13.35v-4c0-3.26.13-4,.67-4s.67.79.67,4.45v4.45Z" />
            <path
                className="c building-fill"
                d="M321.17,228.79h14l.13,1.89.14,1.89,2.14-3.44,2.15-3.45L342,227c1.27.73,2.26,1.53,2.2,1.76s-4.95,8.21-5.74,9.3a4.41,4.41,0,0,1-1.7-.76c-1.5-.89-1.58-.89-1.58-.11a1.22,1.22,0,0,1-.67,1.09c-.56.21-.67-.4-.67-4v-4.22H320.53c-11.58,0-13.36-.09-13.36-.67S309,228.79,321.17,228.79Z" />
            <path
                className="c building-fill"
                d="M343.68,358.27c-.62,0-.86-.1-.56-.22a1.79,1.79,0,0,1,1.12,0C344.54,358.17,344.29,358.27,343.68,358.27Z" />
            <path
                className="c building-fill"
                d="M344,86.9a.9.9,0,0,1,.85,0c.15.15-.11.25-.58.23S343.68,87.05,344,86.9Z" />
            <path
                className="c building-fill"
                d="M339.89,134c1.55,0,2.1-.28,3.56-1.78.95-1,1.83-1.67,1.95-1.55s-.65,1.13-1.73,2.22c-1.68,1.72-2.21,2-3.78,2s-2.08-.28-4-2.23c-1.21-1.22-2-2.23-1.75-2.23a7.6,7.6,0,0,1,2.19,1.78C337.8,133.68,338.35,134,339.89,134Z" />
            <path
                className="c building-fill"
                d="M346.54,358.31c-.52,0-.63-.13-.27-.27a.88.88,0,0,1,.85,0C347.27,358.22,347,358.33,346.54,358.31Z" />
            <path
                className="c building-fill"
                d="M346.54,141.49c-.52,0-.63-.13-.27-.27a.88.88,0,0,1,.85,0C347.27,141.4,347,141.51,346.54,141.49Z" />
            <path
                className="c building-fill"
                d="M346.27,86.9a.91.91,0,0,1,.85,0c.15.15-.12.25-.58.23S345.91,87.05,346.27,86.9Z" />
            <path
                className="c building-fill"
                d="M349.31,350.11c-.15-.37-.07-.67.17-.67s.43.3.43.67-.08.67-.17.67S349.45,350.47,349.31,350.11Z" />
            <path
                className="c building-fill"
                d="M348.91,358.05a1.76,1.76,0,0,1,1.11,0c.31.12.06.22-.55.22S348.6,358.17,348.91,358.05Z" />
            <path
                className="c building-fill"
                d="M350,141.23c.31.12.06.22-.55.22s-.87-.1-.56-.22A1.76,1.76,0,0,1,350,141.23Z" />
            <path
                className="c building-fill"
                d="M346.56,138a19,19,0,0,1,3.54-3.1,18.85,18.85,0,0,1-3.08,3.54l-3.29,3.33-.32,5.78-.09-3.13-.09-3.12Z" />
            <path
                className="c building-fill"
                d="M350.79,353.45c-.24,0-.43-.31-.43-.67s.08-.67.17-.67.29.3.43.67S351,353.45,350.79,353.45Z" />
            <path
                className="c building-fill"
                d="M351.77,355.13c.29.29.43.63.3.76-.3.29-.82-.23-.82-.83C351.25,354.79,351.46,354.81,351.77,355.13Z" />
            <path
                className="c building-fill"
                d="M352.61,357.45a.44.44,0,0,1,.42.45c0,.24-.31.44-.7.44s-.57-.2-.41-.44A.94.94,0,0,1,352.61,357.45Z" />
            <path
                className="c building-fill"
                d="M352,141.23a1.76,1.76,0,0,1,1.11,0c.31.12.05.22-.56.22S351.72,141.35,352,141.23Z" />
            <path
                className="c building-fill"
                d="M338.34,361.7c0-.24.86.5,1.91,1.64,3,3.3,5.47,3.81,9.22,1.9a6.84,6.84,0,0,0,2.91-2.49c.39-.76.82-1.27.95-1.14.55.56-1.53,3-3.44,4.05a8.85,8.85,0,0,1-6.89.72C341.94,366,338.34,362.33,338.34,361.7Z" />
            <path
                className="c building-fill"
                d="M352.21,344.78c-1.73,1.15-3.21,2.42-3.29,2.82s-.23.58-.49.17a3.93,3.93,0,0,0-2.52-.56,12.24,12.24,0,0,1-2.9-.28c-1.28-.49.2-1,2.81-1,2.06,0,2.8-.28,5.52-2.05,2.06-1.32,3.3-1.88,3.58-1.59S354.27,343.41,352.21,344.78Z" />
            <path
                className="c building-fill"
                d="M355.17,141.22a.88.88,0,0,1,.85,0c.15.14-.11.25-.58.23S354.81,141.36,355.17,141.22Z" />
            <path
                className="c building-fill"
                d="M353.25,276.17,349,272.76v-9.05c0-5.55-.17-9.15-.44-9.32-.43-.27-.72,6.62-.63,14.8l0,3.23h-2.53v-8.51l-5.9,0c-3.24,0-6.35,0-6.9,0-1,0-1-.11-1-5.81v-5.79h3.56V248.6c0-3.07-.12-3.79-.67-3.79s-.67.65-.67,3.12v3.12H300.05V228.79H288.92v8.9H274.23v16.92h-6.91c-5.83,0-6.9.1-6.9.67s.45.66,1.34.66h1.33v2.9c0,2.27.15,2.89.67,2.89s.67-.47.67-1.56v-1.55H295.6v41H286c-8.21,0-9.57.09-9.57.66s1.36.67,9.57.67h9.58v15.82l-7,7-7,7-4.67.13-4.68.12-.27,4.68h2c2,0,2,0,2,1.48a3.88,3.88,0,0,0,.29,1.78c.16.17,5.6.3,12.08.3h11.78l3.92-3.83,3.91-3.84,3.46,2.7c3.09,2.41,4.18,2.91,4.18,1.93a23.72,23.72,0,0,0-3.53-3l-3.54-2.66-2.27-6.46c-1.24-3.55-2.69-7.67-3.22-9.16l-1-2.72,1.45-4.63c.8-2.55,2.43-7.74,3.63-11.54l2.18-6.9,11.12-7.79,11.13-7.79,0-4.12,0-4.12h12.46v8.46h2.12c2,0,2.41.25,6.51,3.56,2.42,2,4.48,3.56,4.57,3.56s.16-.3.16-.66S355.58,278,353.25,276.17Zm-23-13.45-.12,10.33-5.57,3.9c-3.06,2.15-8,5.61-10.93,7.7l-5.38,3.79-3.64,11.69c-2,6.42-3.64,11.88-3.64,12.13s1.41,4.44,3.13,9.33l3.13,8.88-3.67,3.69-3.69,3.7h-22.5v-1.55c0-1.55,0-1.56-2-1.56s-2-.05-2-1.34v-1.33H282l14.9-14.93V257.28H280.68c-14.15,0-16.25-.08-16.25-.67s.92-.67,5.57-.67h5.56V239h14.8l-.18-4.46-.18-4.45h8.71v22.26h31.63Z" />
            <ellipse
                className="c building-fill"
                cx="358.59"
                cy="83.2"
                rx="0.67"
                ry="2.23" />
            <path
                className="c building-fill"
                d="M357.65,305,355,297.13l-5.12-3-5.12-3H338c-7.66,0-7.51-.09-5.92,3.43,1.26,2.77,4.47,5.8,6.55,6.17,3.07.54,6.85,2.87,8.25,5.06,2.85,4.52,2.86,10.33,0,13.55-.61.69-.63.81-.09.65a5.62,5.62,0,0,0,1.7-2.07c1.4-2.52,1.42-7.1.05-10.3a13.93,13.93,0,0,0-5.14-5.72c-.8-.45-.8-.53.17-2.52l1-2.06,2,1.41c2.33,1.59,5.1,5.6,6.22,9a12.48,12.48,0,0,1,.46,5.64c-.38,4.66-.87,6.13-2.92,8.82l-1.76,2.32,2.53,1.79c1.38,1,2.65,1.64,2.81,1.47s1.65-3.59,3.3-7.58l3-7.25Zm-1.27,14c-3.36,8.09-2.92,7.48-4.55,6.27l-1.39-1,1.71-2.54c1.85-2.76,2.44-5.31,2.42-10.56,0-3.16-1.16-6.23-3.76-10-1.29-1.88-5.4-5.13-6.48-5.13-.26,0-.92.93-1.47,2.05-1,2-1,2.05-2.63,1.75a12.46,12.46,0,0,1-2.84-.93A12.18,12.18,0,0,1,333,293.7l-.44-1.25h12l4.65,2.71c5.26,3.07,4.63,2.08,8,12.49l1.69,5.18Z" />
            <path
                className="c building-fill"
                d="M365.05,251.83c0,6.3.13,11.91.28,12.46.22.81.08,1-.67,1-.94,0-1-.06-1-12.46,0-10.79.09-12.47.67-12.47S365.05,241.93,365.05,251.83Z" />
            <path
                className="c building-fill"
                d="M365.13,287.45c-1.84-1.48-2.65-2.4-2.36-2.69s1.36.3,3.14,1.69a13.37,13.37,0,0,1,2.7,2.48C368.61,289.89,367.7,289.5,365.13,287.45Z" />
            <path
                className="c building-fill"
                d="M353.55,265.07l7.53,6.14a81.17,81.17,0,0,1,7.53,6.57c0,1-1.57,0-8.35-5.66l-7.23-6,.1-6.08.09-6.08.17,5.57Z" />
            <path
                className="c building-fill"
                d="M364.8,334.79c2.16-1.57,3.2-2.09,3.43-1.72s.29.56.25.6L365,336.24c-2.13,1.57-3.53,2.33-3.72,2C360.87,337.67,361,337.57,364.8,334.79Z" />
            <path
                className="c building-fill"
                d="M363.71,209.64H368c3.22,0,4.22.14,4.08.56s-1.19.57-3,.59c-1.58,0-3.11.07-3.41.11s-.56,2.51-.56,10.54c0,8.92-.1,10.46-.66,10.46s-.68-1.15-.77-6.74l-.13-6.75-1.42,1.2-1.41,1.19-3.45-4.55-3.45-4.54,1.92-1.7a10.49,10.49,0,0,1,2.25-1.7A21.59,21.59,0,0,1,361,212l2.71,3.64Z" />
            <path
                className="c building-fill"
                d="M372.62,110.07l-1.34.2c-.8.11-1.33,0-1.33-.31s.6-.49,1.33-.49c1.26,0,1.34-.1,1.34-1.76a3.4,3.4,0,0,1,.44-2c.3-.18.45,3.56.45,10.89,0,7.14-.16,11.15-.45,11.15s-.44-.29-.44-.65-.84-.68-3.9-.8l-3.89-.15,3.89-.09,3.9-.09Z" />
            <ellipse
                className="c building-fill"
                cx="373.51"
                cy="266.41"
                rx="0.45"
                ry="0.67" />
            <path
                className="c building-fill"
                d="M359.87,350.91c.11-.11.87.15,1.69.58,1.61.84,4.54,1,9.28.5l2.89-.31-2.89.63c-4.24.93-7,.85-9.26-.26C360.53,351.54,359.76,351,359.87,350.91Z" />
            <path
                className="c building-fill"
                d="M350.15,156.22H358l0-7.46c0-4.1,0-18.23,0-31.39,0-21,.1-23.93.68-23.93s.67,1.19.67,8v8h3.56c2.25,0,3.57.18,3.57.48s-1.23.43-3.57.33l-3.56-.14v15.75l1.89.17,1.9.17-1.9.08-1.89.08v49.86h15.09l.16-2.78.16-2.78.09,3.22.08,3.23H359.26v6.68h7.79c4.9,0,7.79.16,7.79.44s-5.64.45-16,.45h-16v4.9c0,4-.12,4.89-.67,4.89s-.67-.84-.67-4.89v-4.9H306.28v24.93h1.34c.73,0,1.33.2,1.33.45s-.9.44-2,.44h-2v-4.9H290l.07,2.68c.06,2-.07,2.67-.55,2.67s-.63-1.1-.63-5.78v-5.77l-5.23-.13-5.24-.12-.12-7.68c-.12-7.45-.09-7.68.78-7.68s.9-.27.9-6.68v-6.68h-3.56c-2.87,0-3.56-.13-3.56-.66s.77-.67,4.23-.67h4.23v14.69h37.4V176.7h-6.68v-7.65a58.33,58.33,0,0,1,.23-7.41,58.2,58.2,0,0,1,.28,7.2l.05,7h3c4.5,0,4.43-.07,4.43,4.27v3.74h37.85V157.55h-7.8c-6.62,0-7.79-.1-7.79-.67S343.51,156.22,350.15,156.22Z" />
            <path
                className="c building-fill"
                d="M381.52,191.31c0,.48-16,.49-16.29,0-.13-.2,3.48-.37,8-.37S381.52,191.11,381.52,191.31Z" />
            <path
                className="c building-fill"
                d="M384.56,360.78c.4.41,0,5.26-.46,6.23a33.36,33.36,0,0,1-6.62,6.7,10.89,10.89,0,0,1-7.4.54c-1.81-.63-1.91-.61-2.89.45-2.52,2.7-8.47,4.44-13.63,4a40.92,40.92,0,0,1-6.73-1.4c-6.54-2-9-1.54-15.76,2.84-5,3.25-7.21,4.09-11,4.18-2.87.08-2.9.09-4.06,1.9a9,9,0,0,1-5.53,4.14c-2,.52-7.33.48-7.33-.06,0-.18,1.66-.34,3.69-.34,2.72,0,4.07-.21,5.23-.82,2.07-1.1,4.23-4,5.15-6.93.74-2.33.74-2.42-.2-3.94-1.32-2.13-1.2-2.61.19-.74,1.15,1.52,1.28,3.27.41,5.42-.28.69,0,.78,2.4.78,3.53,0,5.92-.94,11.55-4.56,6.71-4.31,8.33-4.53,16.11-2.22,7.17,2.12,13.82,1.35,18.58-2.15l1.86-1.36-2.21-2.73a13,13,0,0,1-2.21-3.39c0-.36.61.26,1.36,1.39a23.22,23.22,0,0,0,3.12,3.63c1.66,1.5,1.93,1.6,4.76,1.58,3.73,0,5-.67,8.35-4.34,2.53-2.75,2.57-2.84,2.79-5.91C384.22,362,384.43,360.65,384.56,360.78Z" />
            <ellipse
                className="c building-fill"
                cx="383.3"
                cy="210.09"
                rx="4.45"
                ry="0.45" />
            <ellipse
                className="c building-fill"
                cx="387.31"
                cy="122.6"
                rx="0.45"
                ry="0.67" />
            <path
                className="c building-fill"
                d="M387.76,119.46a1.19,1.19,0,0,1-.45.92c-.24.15-.45-.14-.45-.64s.21-.92.45-.92S387.76,119.11,387.76,119.46Z" />
            <ellipse
                className="c building-fill"
                cx="387.31"
                cy="116.81"
                rx="0.45"
                ry="0.67" />
            <ellipse
                className="c building-fill"
                cx="387.31"
                cy="111.03"
                rx="0.45"
                ry="0.67" />
            <path
                className="c building-fill"
                d="M386.86,113.92c0-.83.13-1,.54-.53s.41.65,0,1.06S386.86,114.75,386.86,113.92Z" />
            <path
                className="c building-fill"
                d="M387.4,107.6c.41.41.41.65,0,1.07s-.54.3-.54-.54S387,107.18,387.4,107.6Z" />
            <path
                className="c building-fill"
                d="M386.86,91.88V89h-3.81c-2.09,0-3.71-.15-3.6-.34a14.32,14.32,0,0,1,4.14-.24l3.94.08.13,3.14c.09,2,0,3.15-.33,3.15S386.86,93.6,386.86,91.88Z" />
            <path
                className="c building-fill"
                d="M371.76,153.1h13.17l1.8-4.12c1.64-3.75,1.72-4.13,1-4.26s-.84-.57-.84-3.48c0-2.11.17-3.23.45-3.06s.45,1.57.45,3.15v2.87h4.89l-.08,2.56-.08,2.56-.17-2.34c-.16-2.31-.17-2.34-1.62-2.34s-1.51.11-3.39,4.45l-1.92,4.45H371.28l.1-5,.09-5,.15,4.78Z" />
            <path
                className="c building-fill"
                d="M396.06,119.15a1.63,1.63,0,0,1,0,1.11c-.12.31-.22.06-.22-.55S395.94,118.84,396.06,119.15Z" />
            <path
                className="c building-fill"
                d="M396,117.36c-.15.15-.25-.11-.24-.58s.13-.63.27-.27A.88.88,0,0,1,396,117.36Z" />
            <path
                className="c building-fill"
                d="M395.77,122.58c0-.39.2-.57.44-.42a.94.94,0,0,1,.45.69.44.44,0,0,1-.45.42C396,123.27,395.77,123,395.77,122.58Z" />
            <path
                className="c building-fill"
                d="M395.77,111c0-.37.2-.67.43-.67s.32.3.17.67-.33.66-.43.66S395.77,111.39,395.77,111Z" />
            <path
                className="c building-fill"
                d="M395.77,113.89c0-.5.19-.79.43-.65a.79.79,0,0,1,.17.92C396,115.08,395.77,115,395.77,113.89Z" />
            <path
                className="c building-fill"
                d="M395.77,108.11c0-.51.19-.8.43-.66a.79.79,0,0,1,.17.92C396,109.29,395.77,109.18,395.77,108.11Z" />
            <path
                className="c building-fill"
                d="M379.39,82.07c.12-.12,6.17-.23,13.45-.23,8.08,0,13.11-.15,13-.41a31,31,0,0,0-3.42-2.64l-3.16-2.22L395.9,79a15.75,15.75,0,0,1-3.54,2.25c-.37-.37,6.67-5.24,7.25-5a41.86,41.86,0,0,1,3.7,2.5l3.14,2.29V106.8H386.86V104c0-2,.14-2.63.5-2.27a3.77,3.77,0,0,1,.32,2.32l-.17,1.82h18.05V82.31H392.35C385.09,82.31,379.26,82.2,379.39,82.07Z" />
            <path
                className="c building-fill"
                d="M406.45,135.85a91.45,91.45,0,0,0,.46,11.47c1.09,3.67-1.5,10.38-5,12.91a7.47,7.47,0,0,1-2.32,1.3c-.27,0-.11-.26.35-.55,4.87-3,7.49-9.23,6.06-14.33l-.56-2h-6.52l-.16,2.34-.16,2.34-.08-2.56-.09-2.56h7.12V126.39h-18l.15,2.71c.09,1.59,0,2.93-.33,3.21s-.49-.64-.49-3.61c0-2.7.17-4.09.5-4.09s.37.29.24.66c-.22.57.39.67,3.92.67s4.21-.11,4.39-.78.2-.74.25,0,.62.78,5.17.78h5.12Z" />
            <path
                className="c building-fill"
                d="M411.12,166.38c3.31-3.75,6-7,6-7.15a4.89,4.89,0,0,0-1.8-1.24l-1.8-.92,1.86-3.43c1-1.89,2-3.6,2.19-3.8s1.55.25,3,1a31.92,31.92,0,0,0,2.93,1.37,5.25,5.25,0,0,0,.73-1.89c1-3.83-.73-15.82-2.9-19.79-1.95-3.58-2.67-4.33-3.6-3.81-.67.38-1.18,0-3.07-2a31,31,0,0,1-2.38-2.78c-.2-.52,6.61-5.81,8.68-6.75s2.28-1.41,3.28-7.26a46.72,46.72,0,0,0-.7-15,50.1,50.1,0,0,0-5.7-12.31c-1.35-2.24-2.3-4.08-2.1-4.08.57,0,5.24,8,6.71,11.51a41.34,41.34,0,0,1,2,6.22,54.19,54.19,0,0,1,0,16.33c-.36,1.72-.66,3.27-.66,3.45s.83.34,1.84.34c2.25,0,3,.85,3,3.36,0,2.7-1.57,4.53-5.76,6.65l-3.53,1.78,1.53,2.41c1.9,3,2.67,5.36,3.53,10.73.77,4.8.88,9.77.27,11.93l-.42,1.46,3.78,1.87c3,1.49,3.73,2,3.53,2.66-.13.43-.35,1.13-.49,1.56-.19.61.4,1.1,2.74,2.25,2,1,2.83,1.62,2.52,1.93s-1.33,0-3.17-.92a19.28,19.28,0,0,0-3.1-1.37c-.21,0-.75.8-1.19,1.78s-1,1.77-1.29,1.77a42.38,42.38,0,0,1-5-2.38L418,159.47l-6.27,7.06c-5.73,6.46-6.65,7.41-6.65,6.87C405.12,173.29,407.82,170.14,411.12,166.38Z" />
            <ellipse
                className="c building-fill"
                cx="447.86"
                cy="85.87"
                rx="3.12"
                ry="0.45" />
            <path
                className="d no-fill building-stroke"
                d="M207,255.94c-2.38,0-4,.19-4,.45s1.63.44,4,.44,4-.18,4-.44S209.37,255.94,207,255.94Zm0,0c-2.38,0-4,.19-4,.45s1.63.44,4,.44,4-.18,4-.44S209.37,255.94,207,255.94Zm6.45,30.28c-.46,0-.66.47-.66,1.56s.2,1.56.66,1.56.67-.48.67-1.56S213.92,286.22,213.45,286.22Zm0,0c-.46,0-.66.47-.66,1.56s.2,1.56.66,1.56.67-.48.67-1.56S213.92,286.22,213.45,286.22Zm8.69-30.28c-1.49,0-2.68.2-2.68.45s1.19.44,2.68.44,2.67-.19,2.67-.44S223.62,255.94,222.14,255.94Zm0,0c-1.49,0-2.68.2-2.68.45s1.19.44,2.68.44,2.67-.19,2.67-.44S223.62,255.94,222.14,255.94Zm0,0c-1.49,0-2.68.2-2.68.45s1.19.44,2.68.44,2.67-.19,2.67-.44S223.62,255.94,222.14,255.94Zm-8.69,30.28c-.46,0-.66.47-.66,1.56s.2,1.56.66,1.56.67-.48.67-1.56S213.92,286.22,213.45,286.22ZM207,255.94c-2.38,0-4,.19-4,.45s1.63.44,4,.44,4-.18,4-.44S209.37,255.94,207,255.94Z" />
            <path
                className="e no-fill border-stroke"
                d="M299.53,345.85l0,5.12.2,5.31" />
            <path
                className="e no-fill border-stroke"
                d="M366.91,394.43l-4.3,17.8,8.85,8.64,3.06,5.11.92,7.52-8.2,7.78-21.66-20.41,2.22-22.65-2.44-3.16-18.3-.17-1.46,1.81,1.48,7.27-.31,30.43-9.19,5.21-.87,8.2-14.19.67-6.67-14.74.22-8.59,16.82-14.21v-2.38L301.4,391l-1.64-34.72H263.41l.21-22.15-1.14-1.44L254.37,329l-8.93-7.9,3.22-2.71.55-1.54-1.46-1.73-4.73,4.7-3.69-.88-7.88-.1.26-11.5-7.79.21-.12-1.43-23,.09V275.79H173.22L164.84,277l-.07,2.64-1.21,3.28.07,6.65.61.23,2.2-1.2,7.08,11.08-11,6.91-8.06-13.14-9.77,1-.29,8.05-12.56-.14v-7.91l-7.28-.07-5.59,8.52-16.82,10L90.5,322.72l-27.6,12-8.4-5.14.37-13.12L65.63,307l11.76-5,6.09-5,6.69-6.62L92,282.09l-4.89-3.42-9.43,0-10,8.7-12.28,1.71-12.24-9.24,3-16.54,14.21-6.35,34.43-.11,5-3.79,4.74-6.88-6.86-13.29-5.5-2-24.6-.09-25.68-9.54-4.27-9.53L42,203.09l8.62,1.78,8.86-.22,19.31,9.76,15.61-13.52-.61-7.59L84,181.59l-5.65-3.22-6.2-2.09-9.87-.1-8.92-8.11-2.09-8.27,8.5-8.08,18.47,3.43L92,160l15.23,15.48,6.08.61,15.27,8.79,15.25-.1.28,8.47,7,.38.37-.6-.77-11.07,13.1-1.42.06,13.85,2.9,15.89,2.43,1.27.68.35h.62v-.73l0-32,29.07-.2h1.75l.06-19.41,36.78-35.26h0l-.11-31.67H264.5V77.34h50V85.2h4.94V78.93H356.7V63.53h34.89c3.82-.3,20.26,4.49,24.66,11.29,11.49.48,19.23,2.07,20,5.7h2.34l1.61,4.83,4.06-1.63,7.05-.06,2.09.86L455,82,456,78.8l-.09-3.47h5.61l4.31,5.81,2.69,9.8L469,99l-7.86-.13L452.51,94l-4.91,5.15-9.73,0-3.37,6,.32,3,2.79,2.6,8.5,3.49,16.93-.25,11.27,1.28.09,5.29-2.62,7.94L463,131.47l-20.78-.18-4.83,2.78,2.39,4.26-.14,2.51.81,1.22,2.28.28,2,2.89,1,.57,4.52-4.43,17.64-.23,1.36,17.09-5.62.06-4.67,5-3.14-1.06-7.81,10.59h-6.8l-11.42,7.33H418.92l-3.73-3.43h-8.28l-10.63-5.25L390,170.21l-6.15,2.13v10.17h5.67v85.88H375.44v3.89l-4.6,5.52,5.69,4.69-5.95,6.67.08,1.51,6.12,18.42.09,2.18L370,332.73l6.32,9.33-1.08,6.76,0,2.46,21.09,16.55,1.87,7.11-2.55,2.85L402.8,386l7.76,5.31,3.7-2,6.05,4.07L418,406l-.87,1.73-5,1.31-5.5.58-3.69-.5-3.58-1.29-3.76-2.24-5.27-3.77-4.2-5.63-4.48-6.53-1.32-3.33,0,1.16Z" />
            <path className="e no-fill border-stroke" d="M301.4,391l-1.64-34.72" />
        </SVGOverlay>
    ),
    firebaseZSpawn: (
        <SVGOverlay attributes={{ viewBox: '0 0 512 512' }} bounds={ImageBounds}>
            <defs>
                <style>
                    {globalStyle}
                    {`
            .d{strokeMiterlimit:10;}
            .d{strokeWidth:0.96px;}
            `}
                </style>
            </defs>
            <rect className="a background-fill" width="512" height="512" />
            <path
                className="b field-fill"
                d="M186.92,399.81l.17-54.81-27.67-.2.74-9.16-15-2.71,0-90.36-7.12.07L137.85,221l3.41-.15V113.45l148.43,0-.05,2.89h42l.2,115-12,0,.05,12.78,55,66-42.95,35.62-26.34-31.66-31.81,27,.1,17.94-29.52-.11.1,40.92Z" />
            <path
                className="c building-fill"
                d="M196.08,201.53a.81.81,0,1,1-.81-.8A.81.81,0,0,1,196.08,201.53Z" />
            <path
                className="c building-fill"
                d="M196.08,198.3a.81.81,0,1,1-1.61,0,.81.81,0,0,1,1.61,0Z" />
            <path
                className="c building-fill"
                d="M198.77,270.19c-1,0-1.14-.13-.65-.65s.79-.49,1.3,0S199.78,270.19,198.77,270.19Z" />
            <path
                className="c building-fill"
                d="M202.27,270.19c-.44,0-.8-.22-.8-.52s.36-.38.8-.22.81.4.81.54S202.72,270.19,202.27,270.19Z" />
            <path
                className="c building-fill"
                d="M205.24,262.92c0-.45.24-.81.53-.81s.54.36.54.81-.24.81-.54.81S205.24,263.37,205.24,262.92Z" />
            <path
                className="c building-fill"
                d="M205.24,259.69c0-.45.24-.81.53-.81s.54.36.54.81-.24.81-.54.81S205.24,260.14,205.24,259.69Z" />
            <path
                className="c building-fill"
                d="M206.31,249.46c0,.45-.24.81-.54.81s-.53-.36-.53-.81.24-.81.53-.81S206.31,249,206.31,249.46Z" />
            <path
                className="c building-fill"
                d="M206.31,236c0,.45-.24.8-.54.8s-.53-.35-.53-.8.24-.81.53-.81S206.31,235.55,206.31,236Z" />
            <path
                className="c building-fill"
                d="M206.31,222.53c0,.45-.24.81-.54.81s-.53-.36-.53-.81.24-.8.53-.8S206.31,222.09,206.31,222.53Z" />
            <path
                className="c building-fill"
                d="M206.31,209.07c0,.45-.24.81-.54.81s-.53-.36-.53-.81.24-.8.53-.8S206.31,208.62,206.31,209.07Z" />
            <path
                className="c building-fill"
                d="M205,269.65a1.17,1.17,0,0,1,.83-.54.53.53,0,0,1,.51.54c0,.29-.38.54-.83.54S204.79,269.94,205,269.65Z" />
            <path
                className="c building-fill"
                d="M206.31,225.74c0,.45-.24.83-.54.83a.52.52,0,0,1-.53-.51,1.16,1.16,0,0,1,.53-.83C206.07,225.05,206.31,225.27,206.31,225.74Z" />
            <path
                className="c building-fill"
                d="M206.31,212.28c0,.45-.24.83-.54.83a.52.52,0,0,1-.53-.51,1.14,1.14,0,0,1,.53-.83C206.07,211.59,206.31,211.81,206.31,212.28Z" />
            <path
                className="c building-fill"
                d="M206.31,239.21c0,.94-.31,1.07-.78.33a.62.62,0,0,1,.24-.85C206.07,238.51,206.31,238.73,206.31,239.21Z" />
            <path
                className="c building-fill"
                d="M206.31,215.78c0,1.3-.29,1.41-.72.32a1,1,0,0,1,.21-1.13C206.09,214.82,206.31,215.15,206.31,215.78Z" />
            <path
                className="c building-fill"
                d="M206.31,266.31c0,1.3-.27,1.5-.83.6a1,1,0,0,1,.23-1.18C206.16,265.28,206.31,265.43,206.31,266.31Z" />
            <path
                className="c building-fill"
                d="M206.31,256.08c0,1.3-.27,1.5-.83.6a1.06,1.06,0,0,1,.23-1.19C206.16,255.07,206.31,255.2,206.31,256.08Z" />
            <path
                className="c building-fill"
                d="M206.31,252.85c0,1.3-.27,1.5-.83.6a1.06,1.06,0,0,1,.23-1.19C206.16,251.84,206.31,252,206.31,252.85Z" />
            <path
                className="c building-fill"
                d="M206.31,242.62c0,1.3-.27,1.5-.83.6a1.06,1.06,0,0,1,.23-1.19C206.16,241.61,206.31,241.74,206.31,242.62Z" />
            <path
                className="c building-fill"
                d="M206.31,229.15c0,1.31-.27,1.51-.83.61a1.06,1.06,0,0,1,.23-1.19C206.16,228.14,206.31,228.28,206.31,229.15Z" />
            <path
                className="c building-fill"
                d="M205.55,233.1c-.45-.72,0-1.55.54-1a1.08,1.08,0,0,1,.11,1C206,233.66,205.89,233.66,205.55,233.1Z" />
            <path
                className="c building-fill"
                d="M205.55,219.64c-.45-.72,0-1.55.54-1a1.11,1.11,0,0,1,.11,1C206,220.2,205.89,220.2,205.55,219.64Z" />
            <path
                className="c building-fill"
                d="M206.36,206.36a.6.6,0,1,1,.2-.83A.62.62,0,0,1,206.36,206.36Z" />
            <path
                className="c building-fill"
                d="M199.58,322.42h-10v10.23c0,8.73-.11,10.23-.81,10.23s-.81-1.59-.81-11v-11h10.77c9.23,0,10.77.11,10.77.8S208.09,322.42,199.58,322.42Z" />
            <path
                className="c building-fill"
                d="M191.77,306.81h15.62v-4.58c0-2.69.22-4.58.54-4.58s.54,2,.54,4.85v4.84H192.85v1.89c0,1.86,0,1.88-2.29,1.79-2-.06-2.06-.11-.54-.29s1.75-.38,1.75-2.08Z" />
            <path
                className="c building-fill"
                d="M209.27,205.21c.45,0,.81.21.81.45s-.36.45-.81.45-.8-.2-.8-.45S208.83,205.21,209.27,205.21Z" />
            <path
                className="c building-fill"
                d="M212.51,205.21c.44,0,.8.21.8.45s-.36.45-.8.45-.81-.2-.81-.45S212.06,205.21,212.51,205.21Z" />
            <path
                className="c building-fill"
                d="M206,245.42h-10v-41.6l-1.21.34c-.67.18-12.54.34-26.39.34-22,0-25.17.11-25.17.8s1.21.81,7.76.81h7.79l0,12c0,10.9.3,13.73.95,11.87.2-.52,4.17-.67,17.43-.67h17.19v43.61H160V257.27c0-12.14-.15-15.62-.67-15.62s-.67,3.66-.67,16.42V274.5h20.06c17.47,0,20.05-.11,20.05-.81,0-.49-.51-.81-1.34-.81h-1.35V247h10c8.51,0,10-.12,10-.81S214.55,245.42,206,245.42Zm-11.57-17.77H160V206.11h34.47Z" />
            <path
                className="c building-fill"
                d="M216,205a.53.53,0,0,1,.51.54c0,.29-.38.54-.83.54s-.69-.25-.51-.54A1.17,1.17,0,0,1,216,205Z" />
            <path
                className="c building-fill"
                d="M220.07,205.6c.15.29-.18.51-.81.51-1.3,0-1.41-.29-.32-.72A1,1,0,0,1,220.07,205.6Z" />
            <path
                className="c building-fill"
                d="M223.3,205.6c.15.29-.18.51-.81.51-1.3,0-1.41-.29-.31-.72A1,1,0,0,1,223.3,205.6Z" />
            <path
                className="c building-fill"
                d="M224.08,361.19c.34,0,.54,3.5.54,9.43V380H205.24v-8.62c0-5.38.2-8.61.53-8.61s.54,3.14.54,8.34v8.35h17.23v-9.15C223.54,364.6,223.75,361.19,224.08,361.19Z" />
            <path
                className="c building-fill"
                d="M225.68,205a1.19,1.19,0,0,1,.83.54c.18.29,0,.54-.52.54s-.83-.25-.83-.54A.53.53,0,0,1,225.68,205Z" />
            <path
                className="c building-fill"
                d="M229.2,205c.45,0,.81.25.81.54s-.36.54-.81.54-.81-.25-.81-.54S228.75,205,229.2,205Z" />
            <path
                className="c building-fill"
                d="M232.43,205c.45,0,.81.25.81.54s-.36.54-.81.54-.81-.25-.81-.54S232,205,232.43,205Z" />
            <path
                className="c building-fill"
                d="M236.47,205.86c0,.14-.38.25-.83.25s-.7-.25-.52-.54C235.44,205.06,236.47,205.3,236.47,205.86Z" />
            <path
                className="c building-fill"
                d="M239.81,205.46c.49.52.36.65-.65.65s-1.14-.13-.65-.65S239.29,205,239.81,205.46Z" />
            <path
                className="c building-fill"
                d="M242.93,345.58c0,9.69-.11,11.3-.81,11.3s-.81-1.61-.81-11.3.12-11.31.81-11.31S242.93,335.88,242.93,345.58Z" />
            <path
                className="c building-fill"
                d="M242.37,205a1.17,1.17,0,0,1,.83.54c.18.29,0,.54-.52.54s-.83-.25-.83-.54A.53.53,0,0,1,242.37,205Z" />
            <path
                className="c building-fill"
                d="M245.6,205a1.17,1.17,0,0,1,.83.54c.18.29-.05.54-.52.54s-.83-.25-.83-.54A.53.53,0,0,1,245.6,205Z" />
            <path
                className="c building-fill"
                d="M249.12,205.21c.45,0,.81.21.81.45s-.36.45-.81.45-.81-.2-.81-.45S248.67,205.21,249.12,205.21Z" />
            <path
                className="c building-fill"
                d="M251,193.19h-1.62v-35H237.07l-.18-2.25c-.09-1.23-.47-2.35-.83-2.46-.51-.18-.67,2.17-.67,10.59v10.81H196.1l-.13-6.6c-.09-3.95-.38-6.59-.7-6.59s-.58,6.14-.67,17.09c-.13,15,0,17.1.67,17.1.45,0,.81-.25.81-.54s9.78-.54,28.27-.54c24.77,0,28.27-.11,28.27-.8C252.62,193.46,252.08,193.19,251,193.19Zm-15.62,0H196.08V176.5h39.31Zm12.39,0H237V159.26h10.77Z" />
            <path
                className="c building-fill"
                d="M251.81,205.57a1.19,1.19,0,0,1,.83-.54.53.53,0,0,1,.52.54c0,.29-.38.54-.83.54S251.63,205.86,251.81,205.57Z" />
            <path
                className="c building-fill"
                d="M255,205.6c.29-.48,1.91-.21,1.91.31,0,.11-.49.2-1.1.2S254.87,205.89,255,205.6Z" />
            <path
                className="c building-fill"
                d="M259.06,206.11c-.63,0-1-.22-.81-.51.3-.48,1.91-.21,1.91.31C260.16,206,259.67,206.11,259.06,206.11Z" />
            <path
                className="c building-fill"
                d="M263.39,205.86c0,.14-.38.25-.83.25s-.69-.25-.51-.54C262.36,205.06,263.39,205.3,263.39,205.86Z" />
            <path
                className="c building-fill"
                d="M228,246.09c-.18-.51,1.25-.67,5.94-.67h6.15l-1.26-2.51a12.59,12.59,0,0,1-1.28-4.49c0-2.18,2-6.51,3.24-6.91.44-.16.26.34-.43,1.26a8.76,8.76,0,0,0,.76,11.93,8.63,8.63,0,0,0,13.06-1.46l.83-1.32-1.32,1.14a7.9,7.9,0,0,1-6.06,2.36,8,8,0,0,1-6.91-11.85,10.09,10.09,0,0,0,1-2.42c0-1,2.56-1.86,5.56-1.88,3.77,0,6.24,1.48,7.76,4.69l1.08,2.26,3.64,0c2.87,0,3.63.21,3.63.83s-.74.81-3.5.81c-3.39,0-3.5.05-3.5,1.37,0,2.18-2,5.52-4.17,7a10,10,0,0,1-7.94,1.32,55.1,55.1,0,0,0-8.84-.65C230.23,246.81,228.14,246.59,228,246.09Z" />
            <path
                className="c building-fill"
                d="M265.81,205.21c.45,0,.81.21.81.45s-.36.45-.81.45-.8-.2-.8-.45S265.37,205.21,265.81,205.21Z" />
            <path
                className="c building-fill"
                d="M269.85,205.6c0,.29-.36.51-.8.51s-.81-.09-.81-.2.36-.36.81-.54S269.85,205.3,269.85,205.6Z" />
            <path
                className="c building-fill"
                d="M272.55,202.88c-.3,0-.54-.49-.54-1.12s.24-.94.54-.76a1.41,1.41,0,0,1,.53,1.1C273.08,202.52,272.84,202.88,272.55,202.88Z" />
            <path
                className="c building-fill"
                d="M273.08,197.72a1.45,1.45,0,0,1-.53,1.12c-.3.18-.54-.18-.54-.78s.24-1.1.54-1.1S273.08,197.29,273.08,197.72Z" />
            <path
                className="c building-fill"
                d="M271.74,205.57a1.2,1.2,0,0,1,.87-.54c.29,0,.38.25.2.54a1.19,1.19,0,0,1-.87.54C271.65,206.11,271.56,205.86,271.74,205.57Z" />
            <path
                className="c building-fill"
                d="M158.93,159.26c-.34,0-.54-3.14-.54-8.34v-8.35h36.08V128H237V134h38.23V149c0,8.28-.11,15.08-.27,15.08s-.27-6.55-.27-14.54V135H237.07l-.18,2.25c-.09,1.23-.44,2.35-.83,2.46s-.67-1.05-.67-4.93v-5.16H196.08v9.15c0,7.79-.11,9.16-.81,9.16s-.8-.61-.8-2.16v-2.15h-35v7.81C159.47,156.3,159.26,159.26,158.93,159.26Z" />
            <path
                className="c building-fill"
                d="M282.6,212.44a2.05,2.05,0,0,1,0,1.34c-.16.39-.27.07-.27-.67S282.44,212.08,282.6,212.44Z" />
            <path
                className="c building-fill"
                d="M282.6,210.55c-.16.39-.27.07-.27-.67s.11-1,.27-.67A2.05,2.05,0,0,1,282.6,210.55Z" />
            <path
                className="c building-fill"
                d="M282.28,206.34c0-.63.16-.77.32-.34a1.15,1.15,0,0,1,0,1C282.4,207.21,282.26,206.9,282.28,206.34Z" />
            <path
                className="c building-fill"
                d="M282.28,203.1c0-.62.16-.76.32-.33a1.15,1.15,0,0,1,0,1C282.4,204,282.26,203.67,282.28,203.1Z" />
            <path
                className="c building-fill"
                d="M284.39,200.73c0,.29-.49.54-1.07.54s-1.08-.25-1.08-.54.49-.54,1.08-.54S284.39,200.43,284.39,200.73Z" />
            <ellipse
                className="c building-fill"
                cx="284.66"
                cy="214.19"
                rx="0.81"
                ry="0.54" />
            <ellipse
                className="c building-fill"
                cx="287.89"
                cy="120.76"
                rx="0.81"
                ry="2.42" />
            <path
                className="c building-fill"
                d="M295.16,274.74c0,.95-.31,1.08-.78.34a.62.62,0,0,1,.24-.85C294.91,274.05,295.16,274.27,295.16,274.74Z" />
            <path
                className="c building-fill"
                d="M297.63,271.94c.13.13-.11.56-.56.94s-.83.45-.83.09C296.24,272.32,297.27,271.58,297.63,271.94Z" />
            <path
                className="c building-fill"
                d="M300.32,269.79c.14.13-.11.56-.56.94s-.83.45-.83.09C298.93,270.17,300,269.43,300.32,269.79Z" />
            <path
                className="c building-fill"
                d="M301.35,268a1.19,1.19,0,0,1,.88-.54c.29,0,.38.24.2.54a1.19,1.19,0,0,1-.87.53C301.26,268.57,301.17,268.33,301.35,268Z" />
            <path
                className="c building-fill"
                d="M304.32,265.59c.74-.87,1.41-.67.83.25a1.31,1.31,0,0,1-.92.58C303.87,266.42,303.91,266.11,304.32,265.59Z" />
            <path
                className="c building-fill"
                d="M307,263.44c.74-.88,1.41-.68.83.24a1.27,1.27,0,0,1-.92.59C306.56,264.27,306.6,264,307,263.44Z" />
            <path
                className="c building-fill"
                d="M310.55,260.63c.14.14-.11.56-.56.94s-.83.45-.83.09C309.16,261,310.19,260.27,310.55,260.63Z" />
            <path
                className="c building-fill"
                d="M317.6,244.7c-.41.41-8.82.54-19.34.29l-6.87-.13V230.25l-1.3,1.55c-2.56,3-12.7,7.25-12.7,5.25,0-.42,1-1,2.29-1.32a18.4,18.4,0,0,0,7.4-3.3c3.28-2.38,3.77-3.79,3.77-11,0-5.77-.06-6.21-1-6.21-1.41,0-2.74-.57-2.74-1.15,0-.25,1.22-.47,2.7-.47h2.69v15.08h8.08c6.82,0,8.07.13,8.07.81s-1.28.8-8.34.8h-8.35v14h13C312,244.34,317.6,244.5,317.6,244.7Z" />
            <path
                className="c building-fill"
                d="M311.85,259.13c.74-.88,1.42-.67.83.25a1.21,1.21,0,0,1-.92.58C311.41,260,311.45,259.64,311.85,259.13Z" />
            <path
                className="c building-fill"
                d="M315.09,187.8v-5.92H288.16V156.57c0-16.51-.18-25.31-.54-25.31s-.65,9.52-.54,41.06l.05,11.71H273.62v9.16H272q-1.62,0-1.62.81c0,.6.63.8,2.42.8h2.43v-9.15h11.84v7.22c0,5.25-.18,7.32-.67,7.54s-.54.38,0,.63a1.31,1.31,0,0,1,.67,1.08c0,.54.65.76,2.16.76s2.15-.22,2.15-.81-.54-.8-1.61-.8h-1.62V187.8Zm-26.93-4.3h25.31v2.69H288.16Z" />
            <path
                className="c building-fill"
                d="M315.62,256.68c0,.27-.36.61-.8.79s-.81.09-.81-.16.36-.6.81-.78S315.62,256.44,315.62,256.68Z" />
            <path
                className="c building-fill"
                d="M315.09,229.54c0-.5.51-.81,1.34-.81s1.35.31,1.35.81-.52.8-1.35.8S315.09,230,315.09,229.54Z" />
            <path
                className="c building-fill"
                d="M318.09,254.17c.14.14-.11.56-.56.94s-.83.45-.83.09C316.7,254.55,317.73,253.81,318.09,254.17Z" />
            <path
                className="c building-fill"
                d="M319.68,253a.61.61,0,1,1,.83.21A.62.62,0,0,1,319.68,253Z" />
            <path
                className="c building-fill"
                d="M322.09,255.4c-.41-.51-.45-.83-.09-.83a1.29,1.29,0,0,1,.92.59C323.5,256.08,322.83,256.28,322.09,255.4Z" />
            <path
                className="c building-fill"
                d="M298.48,279.23c.36.34.52.76.36.92-.36.36-1-.29-1-1C297.85,278.81,298.1,278.85,298.48,279.23Z" />
            <path
                className="c building-fill"
                d="M300.75,281.77c.16.45.07.8-.23.8s-.51-.35-.51-.8.09-.81.2-.81S300.57,281.32,300.75,281.77Z" />
            <path
                className="c building-fill"
                d="M302.7,284.19c0,.29-.11.54-.25.54s-.38-.25-.56-.54-.06-.54.25-.54A.56.56,0,0,1,302.7,284.19Z" />
            <path
                className="c building-fill"
                d="M319.1,255.11c-.51,0-.13.54,3.52,5.12a45.91,45.91,0,0,1,3.77,5.11c0,.81-8.14,7.68-8.55,7.21s-6.91-8.62-7.42-9.32a.3.3,0,0,0-.43,0,36.68,36.68,0,0,0,3.7,5.27l3.95,5.05-4.1,3.68a47.57,47.57,0,0,1-4.38,3.7,27.61,27.61,0,0,1-3-4c-1.48-2.22-2.89-4-3.14-4a39,39,0,0,0-4.89,2.45c-3.73,2.09-5,3.19-8,6.93a33.51,33.51,0,0,0-3.59,5,22.8,22.8,0,0,0,3.5,3.95c1.93,1.91,3.45,3.64,3.36,3.84-.25.65-30.4,25.57-30.94,25.57-.13-.13-.25-4.12-.27-8.9S262,303,261.71,303s-.47,4-.47,8.88v8.89H242.93v-6.73c0-4.13.2-6.74.54-6.74s.54-1,.54-2.15-.25-2.15-.54-2.15-.54.85-.54,1.88v1.89H223.54v-4.58c0-2.69-.22-4.58-.53-4.58s-.54,2-.54,4.85v4.84h19.38v13.47H231.62c-8.73,0-10.23.11-10.23.8s1.46.81,10,.81h10v1.35c0,.83.32,1.34.81,1.34s.81-.51.81-1.34v-1.35h9.74c6.21,0,10.12-.22,10.86-.6,3.79-2.05,64.48-54.52,64.48-55.76C328,265.7,319.39,255.11,319.1,255.11ZM307.68,282.6c-1.95,1.77-11.22,10-12.29,10.88s-1.19.85-4.45-2.51a22.78,22.78,0,0,1-3.32-4c0-.74,5.12-7.16,6.85-8.57a3,3,0,0,1,2.26-.86c.47.16.68.09.43-.15s1-1.24,2.65-2.2l3.07-1.75,2.87,4.13C308.47,281.5,308.58,281.79,307.68,282.6Z" />
            <path
                className="c building-fill"
                d="M324.55,258c-.29-.74-.2-.79.47-.2a2.43,2.43,0,0,1,.83.87C325.85,259.29,324.84,258.75,324.55,258Z" />
            <path
                className="c building-fill"
                d="M326.93,260.3c0-.34.25-.3.63.09s.52.76.36.92C327.56,261.66,326.93,261,326.93,260.3Z" />
            <path
                className="c building-fill"
                d="M330.16,187c0,.56-.56.8-1.88.8h-1.89v-5.92h1.89c1.32,0,1.88.25,1.88.81s-.47.81-1.07.81c-.79,0-1.08.35-1.08,1.34s.29,1.35,1.08,1.35C329.69,186.19,330.16,186.55,330.16,187Z" />
            <path
                className="c building-fill"
                d="M330.16,263.48c0,.14-.24.25-.54.25a.55.55,0,0,1-.53-.56c0-.32.24-.43.53-.25S330.16,263.37,330.16,263.48Z" />
            <path
                className="d border-stroke no-fill"
                d="M186.92,399.81l.17-54.81-27.67-.2.74-9.16-15-2.71,0-90.36-7.12.07L137.85,221l3.41-.15V113.45l148.43,0-.05,2.89h42l.2,115-12,0,.05,12.78,55,66-42.95,35.62-26.34-31.66-31.81,27,.1,17.94-29.52-.11.1,40.92Z" />
        </SVGOverlay>
    ),
    mauerDerToten: (
        <SVGOverlay attributes={{ viewBox: '0 0 512 512' }} bounds={ImageBounds}>
            <defs>
                <style>
                    {globalStyle}
                    {`
                .c{isolation:isolate;}
                .e{strokeWidth:0.36px;}
                .e,.f,.g{strokeMiterlimit:10;}
                .f,.g{strokeWidth:0.96px;}
                `}
                </style>
            </defs>
            <rect className="a background-fill" width="512" height="512" />
            <polygon
                className="b field-fill"
                points="32.17 358.45 78.14 358.45 78.14 391.92 111.61 391.92 111.61 389.59 147.2 389.59 147.2 359.72 160.33 359.72 160.33 372.01 190.83 372.01 190.83 354.64 203.75 354.64 203.75 362.26 267.94 362.26 267.94 313.76 276.41 313.76 277.68 311.85 285.1 322.02 285.1 365.02 325.77 365.02 325.77 334.51 346.53 334.51 346.53 324.98 380.84 324.98 380.84 356.33 475.95 356.33 475.95 323.92 446.3 323.92 446.3 343.62 425.33 343.62 425.33 312.49 340.38 312.49 340.38 303.8 325.56 303.8 325.56 255.29 346.53 255.29 346.53 198.73 383.6 198.73 383.6 222.88 395.25 222.88 395.25 186.66 346.31 186.66 338.26 177.34 325.56 177.34 325.56 124.38 256.08 124.38 256.08 151.28 242.94 151.28 242.94 126.92 210.75 126.92 210.75 130.1 182.36 130.1 182.36 127.14 170.29 127.14 170.29 129.89 148.26 129.89 148.26 176.92 163.08 176.92 163.08 183.69 166.9 183.69 166.9 194.71 183 194.71 183 183.69 188.08 183.69 188.08 273.93 192.95 273.93 192.95 297.66 208.63 313.12 205.87 315.66 205.87 332.19 190.62 332.19 183.42 327.1 147.41 327.1 147.41 297.23 109.26 297.23 109.26 294.67 78.28 294.67 78.28 328.98 32.17 328.98 32.17 358.45" />
            <rect
                className="c background-fill"
                x="206.08"
                y="144.08"
                width="5.08"
                height="39.4" />
            <rect
                className="c background-fill"
                x="206.08"
                y="175.38"
                width="7.71"
                height="8.1" />
            <rect
                className="d building-fill"
                x="234.26"
                y="327.84"
                width="10.49"
                height="10.49" />
            <rect
                className="d building-fill"
                x="241.67"
                y="297.55"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="281.92"
                y="225.21"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="281.92"
                y="207.26"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="281.92"
                y="190.26"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="270.27"
                y="150.86"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="306.38"
                y="126.04"
                width="3.18"
                height="39.25" />
            <rect
                className="d building-fill"
                x="306.38"
                y="200.93"
                width="3.71"
                height="38.19" />
            <rect
                className="d building-fill"
                x="306.38"
                y="252.08"
                width="3.92"
                height="7.06" />
            <rect
                className="d building-fill"
                x="306.38"
                y="280.36"
                width="4.02"
                height="12.78" />
            <rect
                className="d building-fill"
                x="306.38"
                y="313.83"
                width="3.81"
                height="6" />
            <rect
                className="d building-fill"
                x="306.38"
                y="339.25"
                width="3.81"
                height="11.29" />
            <rect
                className="d building-fill"
                x="224.2"
                y="149.12"
                width="3.18"
                height="4.96" />
            <rect
                className="d building-fill"
                x="329.1"
                y="210.12"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="329.1"
                y="233.31"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="241.35"
                y="313.86"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="252.79"
                y="313.86"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="252.79"
                y="335.68"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="252.79"
                y="347.22"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="241.51"
                y="347.22"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="219.64"
                y="347.22"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="219.64"
                y="335.79"
                width="3.18"
                height="3.18" />
            <rect
                className="d building-fill"
                x="393.13"
                y="326.25"
                width="17.48"
                height="11.76" />
            <rect
                className="d building-fill"
                x="222.82"
                y="225.85"
                width="8.26"
                height="16.84" />
            <rect
                className="d building-fill"
                x="197.72"
                y="243.01"
                width="7.31"
                height="12.07" />
            <rect
                className="d building-fill"
                x="213.92"
                y="252.86"
                width="7.31"
                height="10.49" />
            <rect
                className="d building-fill"
                x="207.89"
                y="213.14"
                width="7.63"
                height="23.2" />
            <rect
                className="d building-fill"
                x="189.46"
                y="183.27"
                width="7.63"
                height="26.05" />
            <polygon
                className="d building-fill"
                points="184.06 161.03 192.63 159.28 193.43 165.32 185.01 166.59 184.06 161.03" />
            <polyline
                className="e feature-stroke no-fill"
                points="162.66 172.68 162.66 183.48 169.01 183.48" />
            <polyline
                className="e feature-stroke no-fill"
                points="162.87 164.21 162.87 143.87 192.74 143.87" />
            <polyline
                className="e feature-stroke no-fill"
                points="202.91 144.08 211.59 144.08 211.59 175.01 214.13 175.01 214.13 183.48 205.87 183.48 187.66 183.48" />
            <line
                className="e feature-stroke no-fill"
                x1="205.66"
                y1="144.29"
                x2="205.66"
                y2="183.48" />
            <line
                className="e feature-stroke no-fill"
                x1="288.7"
                y1="125.23"
                x2="288.7"
                y2="252.11" />
            <line
                className="e feature-stroke no-fill"
                x1="282.77"
                y1="176.92"
                x2="288.7"
                y2="176.92" />
            <line
                className="e feature-stroke no-fill"
                x1="325.77"
                y1="177.55"
                x2="325.77"
                y2="255.5" />
            <line
                className="e feature-stroke no-fill"
                x1="325.55"
                y1="303.8"
                x2="325.55"
                y2="334.94" />
            <line
                className="e feature-stroke no-fill"
                x1="346.31"
                y1="321.38"
                x2="346.31"
                y2="325.41" />
            <line
                className="e feature-stroke no-fill"
                x1="345.89"
                y1="312.27"
                x2="345.89"
                y2="315.24" />
            <line
                className="e feature-stroke no-fill"
                x1="446.08"
                y1="342.78"
                x2="458.58"
                y2="342.78" />
            <polyline
                className="e feature-stroke no-fill"
                points="109.07 306.76 143.38 306.76 143.38 379.21 108.01 379.21" />
            <polyline
                className="e feature-stroke no-fill"
                points="160.33 327.52 160.33 338.96 152.28 338.96" />
            <line
                className="e feature-stroke no-fill"
                x1="143.38"
                y1="332.82"
                x2="160.33"
                y2="332.82" />
            <polyline
                className="e feature-stroke no-fill"
                points="151.86 347.86 160.54 347.86 160.54 359.93" />
            <line
                className="e feature-stroke no-fill"
                x1="143.38"
                y1="353.79"
                x2="160.75"
                y2="353.79" />
            <polyline
                className="e feature-stroke no-fill"
                points="92.33 357.6 92.33 366.08 127.07 366.08 132.58 361.2 132.58 325.19 127.5 319.9 92.12 319.9 92.12 326.46" />
            <rect
                className="e feature-stroke no-fill"
                x="306.28"
                y="200.85"
                width="4.02"
                height="65.67" />
            <rect
                className="e feature-stroke no-fill"
                x="306.28"
                y="273.25"
                width="4.02"
                height="56.75" />
            <rect
                className="e feature-stroke no-fill"
                x="306.28"
                y="339.1"
                width="4.02"
                height="25.67" />
            <line
                className="e feature-stroke no-fill"
                x1="192.79"
                y1="273.99"
                x2="195.81"
                y2="273.99" />
            <line
                className="e feature-stroke no-fill"
                x1="203.28"
                y1="273.99"
                x2="206.3"
                y2="273.99" />
            <line
                className="e feature-stroke no-fill"
                x1="209.47"
                y1="311.32"
                x2="208.36"
                y2="312.43" />
            <line
                className="e feature-stroke no-fill"
                x1="215.83"
                y1="305.12"
                x2="218.45"
                y2="302.5" />
            <polygon
                className="f border-stroke no-fill"
                points="32.17 358.45 78.14 358.45 78.14 391.92 111.61 391.92 111.61 389.59 147.2 389.59 147.2 359.72 160.33 359.72 160.33 372.01 190.83 372.01 190.83 354.64 203.75 354.64 203.75 362.26 267.94 362.26 267.94 313.76 276.41 313.76 277.68 311.85 285.1 322.02 285.1 365.02 325.77 365.02 325.77 334.51 346.53 334.51 346.53 324.98 380.84 324.98 380.84 356.33 475.95 356.33 475.95 323.92 446.3 323.92 446.3 343.62 425.33 343.62 425.33 312.49 340.38 312.49 340.38 303.8 325.56 303.8 325.56 255.29 346.53 255.29 346.53 198.73 383.6 198.73 383.6 222.88 395.25 222.88 395.25 186.66 346.31 186.66 338.26 177.34 325.56 177.34 325.56 124.38 256.08 124.38 256.08 151.28 242.94 151.28 242.94 126.92 210.75 126.92 210.75 130.1 182.36 130.1 182.36 127.14 170.29 127.14 170.29 129.89 148.26 129.89 148.26 176.92 163.08 176.92 163.08 183.69 166.9 183.69 166.9 194.71 183 194.71 183 183.69 188.08 183.69 188.08 273.93 192.95 273.93 192.95 297.66 208.63 313.12 205.87 315.66 205.87 332.19 190.62 332.19 183.42 327.1 147.41 327.1 147.41 297.23 109.26 297.23 109.26 294.67 78.28 294.67 78.28 328.98 32.17 328.98 32.17 358.45" />
            <polygon
                className="g border-stroke background-fill"
                points="228.11 175.65 228.11 183.91 232.99 183.91 232.99 274.78 205.66 274.78 205.66 291.73 217.31 302.95 219.01 301.05 233.62 301.05 233.62 287.91 237.01 287.91 237.01 284.95 253.96 284.95 253.96 300.2 267.51 300.2 267.51 301.47 275.77 301.47 277.89 303.17 285.52 292.57 285.52 260.8 288.49 260.8 288.49 252.12 274.72 252.12 274.72 245.76 265.82 233.47 265.82 176.92 272.39 176.92 272.39 171.62 255.65 171.62 255.65 163.99 243.15 163.99 243.15 175.65 228.11 175.65" />
        </SVGOverlay>
    ),
    mauerDerTotenStreets: (
        <SVGOverlay attributes={{ viewBox: '0 0 512 512' }} bounds={ImageBounds}>
            <defs>
                <style>
                    {globalStyle}
                    {`
                .d,.e,.f{strokeMiterlimit:10;}
                .d,.e{strokeWidth:0.36px;}
                .f{strokeWidth:0.96px;}
                `}
                </style>
            </defs>
            <rect className="a background-fill" width="512" height="512" />
            <polygon
                className="b field-fill"
                points="96.3 189.31 96.3 149.18 117.35 149.18 117.35 233.18 124.55 233.18 124.55 185.66 178.79 185.66 192.23 197.18 203.75 186.14 221.03 186.14 221.03 233.18 255.59 233.18 255.59 222.14 239.27 222.14 239.27 125.66 320.86 125.66 320.86 107.9 331.9 106.46 341.02 96.86 364.06 96.86 367.9 98.78 369.34 96.86 382.78 102.14 382.78 95.91 406.78 95.91 406.78 100.7 415.42 100.7 415.42 121.82 423.1 121.82 423.1 139.1 473.98 139.1 473.98 170.3 461.02 170.3 461.02 191.9 473.5 191.9 473.5 228.86 442.78 228.86 442.78 302.29 449.5 302.29 449.5 327.25 476.38 327.25 476.38 409.81 449.5 409.81 449.5 391.09 437.5 391.09 437.5 399.73 390.46 399.73 390.46 394.93 362.14 394.93 362.14 360.85 348.22 360.85 348.22 373.81 320.86 373.81 320.86 416.05 258.95 416.05 258.95 360.37 273.35 360.37 273.35 308.53 319.9 308.53 319.9 301.81 323.26 301.81 323.26 297.97 254.63 297.97 236.87 289.33 218.63 289.33 218.63 345.49 200.39 345.49 186.47 336.37 169.19 341.17 165.35 346.45 144.71 345.97 136.55 336.37 128.39 336.37 128.39 289.33 121.19 289.33 121.19 283.57 117.83 283.57 117.83 335.89 90 335.89 90 331.09 50.64 331.09 50.64 295.1 35.76 295.1 35.76 213.5 50.64 213.5 50.64 189.31 96.3 189.31" />
            <polygon
                className="c building-fill"
                points="181.64 217.04 185.05 223.44 195.08 218.32 191.88 212.13 181.64 217.04" />
            <polygon
                className="c building-fill"
                points="199.77 208.29 200.62 215.76 210.01 219.81 212.57 217.04 211.08 206.16 199.77 208.29" />
            <polygon
                className="c building-fill"
                points="75.18 246.27 92.04 256.08 86.49 265.25 69.64 255.44 75.18 246.27" />
            <polygon
                className="c building-fill"
                points="124.04 254.37 143.45 254.37 143.45 264.83 124.25 264.83 124.04 254.37" />
            <rect
                className="c building-fill"
                x="198.49"
                y="254.59"
                width="19.84"
                height="10.45" />
            <rect
                className="c building-fill"
                x="104.41"
                y="217.89"
                width="11.52"
                height="14.72" />
            <polygon
                className="c building-fill"
                points="116.57 282.75 108.25 282.75 103.77 292.13 110.81 306.64 116.57 306.64 116.57 282.75" />
            <polygon
                className="c building-fill"
                points="161.58 289.57 169.69 304.72 179.29 299.6 180.78 289.57 161.58 289.57" />
            <polygon
                className="c building-fill"
                points="140.68 313.25 150.49 314.96 151.34 328.61 140.89 326.48 140.68 313.25" />
            <circle className="c building-fill" cx="172.14" cy="318.37" r="5.87" />
            <polygon
                className="c building-fill"
                points="191.45 310.91 204.25 308.56 199.56 323.92 191.66 318.59 191.45 310.91" />
            <polygon
                className="c building-fill"
                points="202.33 289.57 208.3 303.65 217.26 303.65 217.26 289.36 202.33 289.57" />
            <polygon
                className="c building-fill"
                points="242.86 250.32 250.54 239.87 255.02 243.28 247.13 253.52 242.86 250.32" />
            <polygon
                className="c building-fill"
                points="134.06 195.92 146.44 194.43 146.65 205.09 138.97 208.08 134.06 195.92" />
            <polygon
                className="c building-fill"
                points="160.73 203.39 171.61 199.55 174.38 210.43 160.73 213.41 158.17 209.57 160.73 203.39" />
            <ellipse
                className="c building-fill"
                cx="173.64"
                cy="204.99"
                rx="5.65"
                ry="6.29" />
            <polygon
                className="c building-fill"
                points="251.82 267.6 256.09 274.21 273.16 264.4 268.89 258 251.82 267.6" />
            <polygon
                className="c building-fill"
                points="289.8 246.91 310.49 251.17 307.29 263.76 286.81 259.28 289.8 246.91" />
            <polygon
                className="c building-fill"
                points="263.77 223.01 275.08 223.01 275.08 232.61 263.98 232.61 263.77 223.01" />
            <polygon
                className="c building-fill"
                points="285.53 223.23 294.06 223.23 305.37 236.03 300.46 240.93 285.53 223.23" />
            <polygon
                className="c building-fill"
                points="333.1 218.11 343.13 213.63 351.24 218.53 350.6 235.17 341.85 246.69 336.73 244.13 330.33 228.35 333.1 218.11" />
            <polygon
                className="c building-fill"
                points="330.54 262.91 337.37 265.47 330.76 283.17 324.14 281.04 330.54 262.91" />
            <polygon
                className="c building-fill"
                points="287.24 271.01 294.06 273.57 289.58 286.8 298.33 296.83 273.8 297.25 275.93 291.92 281.48 289.15 287.24 271.01" />
            <polygon
                className="c building-fill"
                points="356.14 284.67 361.9 280.61 378.33 301.73 369.37 301.73 356.14 284.67" />
            <polygon
                className="c building-fill"
                points="398.17 301.73 398.17 294.27 405.21 294.27 406.7 276.99 410.12 275.28 441.48 272.93 441.48 301.52 398.17 301.73" />
            <polygon
                className="c building-fill"
                points="353.16 251.17 371.08 245.84 373.21 252.24 355.29 257.79 353.16 251.17" />
            <polygon
                className="c building-fill"
                points="375.77 266.11 394.76 267.6 393.9 274.43 374.92 272.72 375.77 266.11" />
            <polygon
                className="c building-fill"
                points="406.92 253.09 403.72 259.71 420.57 267.17 423.98 261.2 406.92 253.09" />
            <polygon
                className="c building-fill"
                points="367.02 217.04 377.9 214.27 377.9 219.81 368.3 222.16 367.02 217.04" />
            <polygon
                className="c building-fill"
                points="410.12 229.41 442.12 229.41 442.12 245.41 418.01 245.41 410.12 229.41" />
            <polygon
                className="c building-fill"
                points="344.62 164.13 361.69 171.17 359.56 177.57 341.85 170.32 344.62 164.13" />
            <polygon
                className="c building-fill"
                points="359.98 146.85 370.86 138.53 376.2 143.65 374.28 154.32 368.3 156.67 359.98 146.85" />
            <rect
                className="c building-fill"
                x="340.36"
                y="195.28"
                width="3.2"
                height="4.27" />
            <rect
                className="c building-fill"
                x="273.8"
                y="384.72"
                width="11.31"
                height="9.17" />
            <polyline
                className="d feature-stroke no-fill"
                points="51.5 212.56 95.45 212.56 95.45 188.88" />
            <line
                className="d feature-stroke no-fill"
                x1="54.28"
                y1="224.51"
                x2="54.28"
                y2="212.77" />
            <line
                className="d feature-stroke no-fill"
                x1="44.25"
                y1="232.4"
                x2="46.17"
                y2="232.4" />
            <line
                className="d feature-stroke no-fill"
                x1="53.21"
                y1="232.19"
                x2="54.7"
                y2="232.19" />
            <polyline
                className="d feature-stroke no-fill"
                points="50.86 295.12 77.96 295.12 89.9 309.2 89.9 331.6" />
            <line
                className="d feature-stroke no-fill"
                x1="128.94"
                y1="288.93"
                x2="144.73"
                y2="288.93" />
            <line
                className="d feature-stroke no-fill"
                x1="152.2"
                y1="288.93"
                x2="181.21"
                y2="288.93" />
            <line
                className="d feature-stroke no-fill"
                x1="190.38"
                y1="288.93"
                x2="217.48"
                y2="288.93" />
            <line
                className="d feature-stroke no-fill"
                x1="125.74"
                y1="232.19"
                x2="146.01"
                y2="232.19" />
            <line
                className="d feature-stroke no-fill"
                x1="166.06"
                y1="232.19"
                x2="198.17"
                y2="232.19" />
            <line
                className="d feature-stroke no-fill"
                x1="205.74"
                y1="232.19"
                x2="219.61"
                y2="232.19" />
            <polyline
                className="d feature-stroke no-fill"
                points="240.09 234.32 240.09 241.79 231.98 242 227.93 268.67 241.8 275.49" />
            <polyline
                className="d feature-stroke no-fill"
                points="256.09 222.37 303.24 222.37 306.86 218.75" />
            <polyline
                className="d feature-stroke no-fill"
                points="312.41 213.63 314.97 210.64 314.97 188.03" />
            <polyline
                className="d feature-stroke no-fill"
                points="321.16 127.01 321.16 181.84 314.97 190.8" />
            <polyline
                className="d feature-stroke no-fill"
                points="334.38 182.91 334.38 156.88 321.16 156.88" />
            <line
                className="d feature-stroke no-fill"
                x1="334.81"
                y1="140.03"
                x2="321.16"
                y2="140.03" />
            <line
                className="d feature-stroke no-fill"
                x1="343.34"
                y1="108.67"
                x2="343.34"
                y2="111.01" />
            <line
                className="d feature-stroke no-fill"
                x1="343.34"
                y1="119.97"
                x2="343.34"
                y2="131.49" />
            <line
                className="d feature-stroke no-fill"
                x1="343.34"
                y1="138.96"
                x2="343.34"
                y2="141.09" />
            <line
                className="d feature-stroke no-fill"
                x1="383.24"
                y1="115.71"
                x2="383.24"
                y2="154.11" />
            <line
                className="d feature-stroke no-fill"
                x1="396.25"
                y1="152.19"
                x2="383.24"
                y2="152.19" />
            <polyline
                className="d feature-stroke no-fill"
                points="402.44 152.4 423.13 152.4 423.13 140.24" />
            <line
                className="d feature-stroke no-fill"
                x1="404.14"
                y1="121.04"
                x2="414.81"
                y2="121.04" />
            <line
                className="d feature-stroke no-fill"
                x1="410.97"
                y1="167.33"
                x2="410.97"
                y2="152.4" />
            <line
                className="d feature-stroke no-fill"
                x1="383.02"
                y1="165.63"
                x2="383.02"
                y2="211.92" />
            <polyline
                className="d feature-stroke no-fill"
                points="397.1 228.56 387.08 228.56 378.33 220.67 378.33 212.13 387.93 212.13" />
            <line
                className="d feature-stroke no-fill"
                x1="403.08"
                y1="228.77"
                x2="442.54"
                y2="228.77" />
            <line
                className="d feature-stroke no-fill"
                x1="383.24"
                y1="168.4"
                x2="386.44"
                y2="168.4" />
            <line
                className="d feature-stroke no-fill"
                x1="388.36"
                y1="168.19"
                x2="391.13"
                y2="168.19" />
            <line
                className="d feature-stroke no-fill"
                x1="399.66"
                y1="168.4"
                x2="402.65"
                y2="168.4" />
            <line
                className="d feature-stroke no-fill"
                x1="404.78"
                y1="168.19"
                x2="407.77"
                y2="168.19" />
            <line
                className="d feature-stroke no-fill"
                x1="409.26"
                y1="168.4"
                x2="412.68"
                y2="168.4" />
            <polyline
                className="d feature-stroke no-fill"
                points="414.6 168.4 416.94 168.4 416.94 170.11" />
            <line
                className="d feature-stroke no-fill"
                x1="416.52"
                y1="171.39"
                x2="416.52"
                y2="174.16" />
            <line
                className="d feature-stroke no-fill"
                x1="416.52"
                y1="176.51"
                x2="416.52"
                y2="179.49" />
            <line
                className="d feature-stroke no-fill"
                x1="416.3"
                y1="181.2"
                x2="416.3"
                y2="184.61" />
            <line
                className="d feature-stroke no-fill"
                x1="416.3"
                y1="186.53"
                x2="416.3"
                y2="189.31" />
            <line
                className="d feature-stroke no-fill"
                x1="416.52"
                y1="191.23"
                x2="416.52"
                y2="194.64" />
            <line
                className="d feature-stroke no-fill"
                x1="416.3"
                y1="196.35"
                x2="416.3"
                y2="199.33" />
            <line
                className="d feature-stroke no-fill"
                x1="416.52"
                y1="201.25"
                x2="416.52"
                y2="204.45" />
            <line
                className="d feature-stroke no-fill"
                x1="416.73"
                y1="206.16"
                x2="416.73"
                y2="209.36" />
            <line
                className="d feature-stroke no-fill"
                x1="416.52"
                y1="211.07"
                x2="416.52"
                y2="214.48" />
            <line
                className="d feature-stroke no-fill"
                x1="416.73"
                y1="216.19"
                x2="416.73"
                y2="219.17" />
            <line
                className="d feature-stroke no-fill"
                x1="416.73"
                y1="220.88"
                x2="416.73"
                y2="224.08" />
            <line
                className="d feature-stroke no-fill"
                x1="416.73"
                y1="226.21"
                x2="416.73"
                y2="228.35" />
            <line
                className="d feature-stroke no-fill"
                x1="239.45"
                y1="180.35"
                x2="242.44"
                y2="180.35" />
            <line
                className="d feature-stroke no-fill"
                x1="244.14"
                y1="180.56"
                x2="247.98"
                y2="180.56" />
            <line
                className="d feature-stroke no-fill"
                x1="249.69"
                y1="180.56"
                x2="252.89"
                y2="180.56" />
            <line
                className="d feature-stroke no-fill"
                x1="254.17"
                y1="180.56"
                x2="258.01"
                y2="180.56" />
            <line
                className="d feature-stroke no-fill"
                x1="259.5"
                y1="180.56"
                x2="262.28"
                y2="180.77" />
            <line
                className="d feature-stroke no-fill"
                x1="264.84"
                y1="180.77"
                x2="268.04"
                y2="180.77" />
            <line
                className="d feature-stroke no-fill"
                x1="239.45"
                y1="203.39"
                x2="242.44"
                y2="203.39" />
            <line
                className="d feature-stroke no-fill"
                x1="244.14"
                y1="203.6"
                x2="247.98"
                y2="203.6" />
            <line
                className="d feature-stroke no-fill"
                x1="249.69"
                y1="203.6"
                x2="252.89"
                y2="203.6" />
            <line
                className="d feature-stroke no-fill"
                x1="254.17"
                y1="203.6"
                x2="258.01"
                y2="203.6" />
            <line
                className="d feature-stroke no-fill"
                x1="259.5"
                y1="203.6"
                x2="262.28"
                y2="203.81" />
            <line
                className="d feature-stroke no-fill"
                x1="264.84"
                y1="203.81"
                x2="268.04"
                y2="203.81" />
            <polyline
                className="d feature-stroke no-fill"
                points="268.04 186.43 268.04 173.09 315.08 173.09 315.08 185.57" />
            <polyline
                className="d feature-stroke no-fill"
                points="267.82 193.47 267.82 217.57 271.56 217.57 271.56 222.37" />
            <line
                className="d feature-stroke no-fill"
                x1="320.36"
                y1="308.35"
                x2="320.36"
                y2="317.47" />
            <polyline
                className="d feature-stroke no-fill"
                points="323.56 301.63 360.68 301.63 442.6 301.63" />
            <line
                className="d feature-stroke no-fill"
                x1="360.84"
                y1="319.55"
                x2="360.84"
                y2="301.63" />
            <polyline
                className="d feature-stroke no-fill"
                points="348.52 360.67 348.52 319.55 364.04 319.55 364.04 338.59" />
            <polyline
                className="d feature-stroke no-fill"
                points="361.8 360.03 361.8 338.91 367.24 338.91" />
            <line
                className="d feature-stroke no-fill"
                x1="388.04"
                y1="317.15"
                x2="388.04"
                y2="338.91" />
            <line
                className="d feature-stroke no-fill"
                x1="392.2"
                y1="326.59"
                x2="388.04"
                y2="326.59" />
            <line
                className="d feature-stroke no-fill"
                x1="417.64"
                y1="314.91"
                x2="417.64"
                y2="301.63" />
            <line
                className="d feature-stroke no-fill"
                x1="401.64"
                y1="326.59"
                x2="437.48"
                y2="326.59" />
            <line
                className="d feature-stroke no-fill"
                x1="449.96"
                y1="337.31"
                x2="449.96"
                y2="375.39" />
            <polyline
                className="d feature-stroke no-fill"
                points="449.96 380.99 449.96 393.79 475.72 393.79" />
            <line
                className="d feature-stroke no-fill"
                x1="390.6"
                y1="389.63"
                x2="390.6"
                y2="395.23" />
            <polyline
                className="d feature-stroke no-fill"
                points="305 405.15 285.48 405.15 285.48 359.39" />
            <polyline
                className="d feature-stroke no-fill"
                points="273.48 359.39 321 359.39 321 326.27 335.4 326.27" />
            <line
                className="d feature-stroke no-fill"
                x1="273.48"
                y1="330.43"
                x2="320.84"
                y2="330.43" />
            <line
                className="d feature-stroke no-fill"
                x1="315.4"
                y1="404.99"
                x2="320.52"
                y2="404.99" />
            <rect
                className="e feature-stroke background-fill"
                x="381.96"
                y="338.75"
                width="54.72"
                height="38.72" />
            <polygon
                className="f border-stroke no-fill"
                points="96.3 189.31 96.3 149.18 117.35 149.18 117.35 233.18 124.55 233.18 124.55 185.66 178.79 185.66 192.23 197.18 203.75 186.14 221.03 186.14 221.03 233.18 255.59 233.18 255.59 222.14 239.27 222.14 239.27 125.66 320.86 125.66 320.86 107.9 331.9 106.46 341.02 96.86 364.06 96.86 367.9 98.78 369.34 96.86 382.78 102.14 382.78 95.91 406.78 95.91 406.78 100.7 415.42 100.7 415.42 121.82 423.1 121.82 423.1 139.1 473.98 139.1 473.98 170.3 461.02 170.3 461.02 191.9 473.5 191.9 473.5 228.86 442.78 228.86 442.78 302.29 449.5 302.29 449.5 327.25 476.38 327.25 476.38 409.81 449.5 409.81 449.5 391.09 437.5 391.09 437.5 399.73 390.46 399.73 390.46 394.93 362.14 394.93 362.14 360.85 348.22 360.85 348.22 373.81 320.86 373.81 320.86 416.05 258.95 416.05 258.95 360.37 273.35 360.37 273.35 308.53 319.9 308.53 319.9 301.81 323.26 301.81 323.26 297.97 254.63 297.97 236.87 289.33 218.63 289.33 218.63 345.49 200.39 345.49 186.47 336.37 169.19 341.17 165.35 346.45 144.71 345.97 136.55 336.37 128.39 336.37 128.39 289.33 121.19 289.33 121.19 283.57 117.83 283.57 117.83 335.89 90 335.89 90 331.09 50.64 331.09 50.64 295.1 35.76 295.1 35.76 213.5 50.64 213.5 50.64 189.31 96.3 189.31" />
        </SVGOverlay>
    ),
    forsaken: (
        <SVGOverlay attributes={{ viewBox: '0 0 512 512' }} bounds={ImageBounds}>
            <defs>
                <style>
                    {globalStyle}
                    {`
                .c,.d,.f{strokeMiterlimit:10;}
                .c,.d{strokeWidth:0.52px;}
                .d{stroke-dasharray:2.62;}
                .f{strokeWidth:0.96px;}
                `}
                </style>
            </defs>
            <rect className="a background-fill" width="512" height="512" />
            <path
                className="b field-fill"
                d="M38.72,109.57H54.41V94.67h69v-22H165V86.82h24.32v11h7.06V81.33h5.49V62.5h42.37V79h25.1v25.89h36.09v7.06s66.53-1.25,88.66,0,59.86,25.31,68.26,56.49c3.06,11.36,0,47.07,0,47.07L455.32,221v38.45h18.83v22H482V407.71H468.66v11.77H332.93V374.76h8.63v-80l17.26-18h24.32V259.43h50.22v-33l-6.28-9.41V181.75s-1.21-31.37-42.37-34.52c-35.2-2.69-141.22,0-141.22,0v45.51H162.68v-9.42l3.93-7.06L157.19,181h-7.06v-5.49H136.79V150.37h-11v12.55H69.32V147.23l-11-7.06H38.72Z" />
            <polygon
                className="b field-fill"
                points="273 215.17 286.08 203.67 329.5 203.67 343.1 216.22 343.1 264.34 333.16 277.42 294.97 277.42 294.97 285.79 301.25 292.59 301.25 300.43 296.02 306.71 290.79 306.71 286.6 310.89 275.1 310.89 275.1 316.65 286.6 316.65 294.97 326.06 294.97 355.88 287.65 355.88 287.65 405.05 262.02 405.05 262.02 414.46 195.07 414.46 195.07 457.35 160.54 457.35 152.18 463.63 139.62 463.63 139.62 459.97 135.44 459.97 135.44 463.63 83.13 463.63 83.13 434.34 69.53 434.34 69.53 397.2 89.93 397.2 94.11 391.45 87.84 381.51 87.84 353.26 117.65 353.26 117.65 356.75 136.48 356.75 136.48 330.77 159.5 330.77 165.25 325.54 187.74 325.54 187.74 312.99 251.03 312.99 251.03 318.74 254.17 318.74 254.17 310.37 231.16 310.37 231.16 261.2 258.88 261.2 258.88 258.06 269.87 258.06 269.87 263.3 273 263.3 273 215.17" />
            <polygon
                className="b field-fill"
                points="55.8 238.71 33.3 238.71 33.3 262.77 50.57 262.77 50.57 278.99 34.87 278.99 34.87 300.43 92.94 300.43 92.94 311.94 131.12 311.94 131.12 212.03 90.32 212.03 90.32 196.87 55.8 196.87 55.8 238.71" />
            <line
                className="c feature-stroke no-fill"
                x1="61.47"
                y1="137.82"
                x2="70.89"
                y2="137.82" />
            <polyline
                className="c feature-stroke no-fill"
                points="86.58 144.88 86.58 155.08 117.18 155.08 117.18 101.73 87.36 101.73 87.36 113.5" />
            <line
                className="c feature-stroke no-fill"
                x1="80.3"
                y1="95.45"
                x2="80.3"
                y2="112.71" />
            <line
                className="c feature-stroke no-fill"
                x1="80.51"
                y1="141.94"
                x2="80.51"
                y2="160.25" />
            <line
                className="c feature-stroke no-fill"
                x1="117.13"
                y1="117.88"
                x2="124.45"
                y2="117.88" />
            <line
                className="c feature-stroke no-fill"
                x1="117.65"
                y1="137.24"
                x2="125.5"
                y2="137.24" />
            <polyline
                className="c feature-stroke no-fill"
                points="124.97 97.48 124.97 105.33 124.97 146.65" />
            <line
                className="c feature-stroke no-fill"
                x1="132.3"
                y1="106.37"
                x2="124.98"
                y2="106.37" />
            <line
                className="c feature-stroke no-fill"
                x1="141.71"
                y1="72.9"
                x2="141.71"
                y2="91.21" />
            <polyline
                className="c feature-stroke no-fill"
                points="165.25 86.5 165.25 113.7 194.54 113.7" />
            <polyline
                className="c feature-stroke no-fill"
                points="168.39 141.42 168.39 174.9 203.96 174.9" />
            <line
                className="c feature-stroke no-fill"
                x1="239.53"
                y1="148.22"
                x2="168.39"
                y2="148.22" />
            <line
                className="c feature-stroke no-fill"
                x1="238.48"
                y1="142.99"
                x2="167.87"
                y2="142.99" />
            <polyline
                className="c feature-stroke no-fill"
                points="199.77 108.99 269.87 108.99 269.87 105.33" />
            <line
                className="c feature-stroke no-fill"
                x1="201.87"
                y1="112.65"
                x2="265.16"
                y2="112.65" />
            <polyline
                className="c feature-stroke no-fill"
                points="265.68 108.47 265.68 116.84 260.97 123.11 260.97 142.99" />
            <polyline
                className="c feature-stroke no-fill"
                points="218.08 175.42 209.71 175.42 209.71 182.22 190.36 182.22" />
            <line
                className="c feature-stroke no-fill"
                x1="216.51"
                y1="190.07"
                x2="216.51"
                y2="175.42" />
            <polyline
                className="c feature-stroke no-fill"
                points="206.05 82.05 237.7 82.05 237.7 71.85 224.62 71.85" />
            <path
                className="c feature-stroke no-fill"
                d="M372.91,137s57,1.84,63.29,47.08c1.36,9.78,0,39.49,0,39.49" />
            <path
                className="c feature-stroke no-fill"
                d="M375.26,120.5s70.09,2.09,78.2,57.8c1.41,9.7.79,39.23.79,39.23" />
            <polyline
                className="c feature-stroke no-fill"
                points="300.73 205.24 300.73 226.68 293.4 233.48 293.4 241.33 300.73 241.33" />
            <line
                className="c feature-stroke no-fill"
                x1="274.05"
                y1="260.16"
                x2="291.57"
                y2="277.68" />
            <line
                className="c feature-stroke no-fill"
                x1="287.13"
                y1="234.53"
                x2="341.53"
                y2="234.53" />
            <line
                className="c feature-stroke no-fill"
                x1="274.57"
                y1="234.53"
                x2="280.85"
                y2="234.53" />
            <polyline
                className="c feature-stroke no-fill"
                points="307 249.17 316.42 249.17 316.42 259.63 323.74 259.63 329.5 254.93" />
            <line
                className="c feature-stroke no-fill"
                x1="330.54"
                y1="246.03"
                x2="330.54"
                y2="235.05" />
            <line
                className="c feature-stroke no-fill"
                x1="315.9"
                y1="275.33"
                x2="315.9"
                y2="265.39" />
            <line
                className="c feature-stroke no-fill"
                x1="273.53"
                y1="249.17"
                x2="280.85"
                y2="249.17" />
            <line
                className="c feature-stroke no-fill"
                x1="286.6"
                y1="249.17"
                x2="299.16"
                y2="249.17" />
            <polyline
                className="c feature-stroke no-fill"
                points="272.48 270.62 276.14 270.62 285.03 278.46 285.03 285.79 290.79 285.79" />
            <line
                className="c feature-stroke no-fill"
                x1="254.7"
                y1="309.85"
                x2="262.02"
                y2="309.85" />
            <line
                className="c feature-stroke no-fill"
                x1="276.67"
                y1="306.71"
                x2="289.22"
                y2="306.71" />
            <polyline
                className="c feature-stroke no-fill"
                points="218.08 314.03 218.08 343.85 214.42 343.85" />
            <path
                className="c feature-stroke no-fill"
                d="M215.47,351.69h3.66v6.8h30.34s.52-4.18,4.18-3.66" />
            <polyline
                className="c feature-stroke no-fill"
                points="278.41 354.31 287.3 354.31 287.3 352.22" />
            <line
                className="c feature-stroke no-fill"
                x1="282.42"
                y1="326.59"
                x2="282.42"
                y2="348.03" />
            <line
                className="c feature-stroke no-fill"
                x1="218.6"
                y1="327.11"
                x2="249.99"
                y2="327.11" />
            <polyline
                className="c feature-stroke no-fill"
                points="218.6 336.52 238.48 336.52 238.48 334.43" />
            <polyline
                className="c feature-stroke no-fill"
                points="224.36 413.24 214.42 413.24 214.42 402.43 214.42 379.42 261.15 379.42 261.15 413.94" />
            <line
                className="c feature-stroke no-fill"
                x1="223.84"
                y1="408.88"
                x2="214.42"
                y2="408.88" />
            <line
                className="c feature-stroke no-fill"
                x1="214.42"
                y1="399.29"
                x2="191.93"
                y2="399.29" />
            <rect
                className="c feature-stroke no-fill"
                x="160.02"
                y="384.12"
                width="32.43"
                height="17.78" />
            <polyline
                className="c feature-stroke no-fill"
                points="188.79 326.59 188.79 344.37 186.17 344.37" />
            <line
                className="c feature-stroke no-fill"
                x1="165.77"
                y1="325.54"
                x2="165.77"
                y2="339.14" />
            <line
                className="c feature-stroke no-fill"
                x1="187.13"
                y1="355.97"
                x2="163.6"
                y2="355.97" />
            <polyline
                className="c feature-stroke no-fill"
                points="137.35 355.88 163.68 355.88 163.68 361.11 167.87 365.29 167.87 384.12" />
            <polyline
                className="c feature-stroke no-fill"
                points="185.13 384.12 178.85 377.32 178.85 367.91 181.47 365.29 181.47 353.26" />
            <path
                className="c feature-stroke no-fill"
                d="M145.9,339.14s4.71,8.37,10.46.52" />
            <polyline
                className="c feature-stroke no-fill"
                points="100.39 385.17 100.39 396.15 103.53 396.15 103.53 409.23" />
            <polyline
                className="c feature-stroke no-fill"
                points="84.18 433.82 84.18 423.88 90.63 423.88" />
            <polyline
                className="c feature-stroke no-fill"
                points="90.45 462.76 90.45 405.57 90.45 398.25" />
            <polyline
                className="c feature-stroke no-fill"
                points="134.56 462.76 134.39 433.82 126.02 424.4 108.24 424.4 108.24 413.42 101.44 406.62 90.45 406.62" />
            <line
                className="c feature-stroke no-fill"
                x1="94.11"
                y1="412.89"
                x2="94.11"
                y2="423.35" />
            <line
                className="c feature-stroke no-fill"
                x1="90.45"
                y1="452.12"
                x2="134.39"
                y2="452.12" />
            <line
                className="c feature-stroke no-fill"
                x1="160.02"
                y1="401.91"
                x2="160.02"
                y2="457.88" />
            <line
                className="c feature-stroke no-fill"
                x1="287.13"
                y1="377.85"
                x2="279.8"
                y2="377.85" />
            <line
                className="c feature-stroke no-fill"
                x1="49.52"
                y1="279.51"
                x2="49.52"
                y2="298.86" />
            <line
                className="c feature-stroke no-fill"
                x1="75.15"
                y1="298.86"
                x2="75.15"
                y2="278.99" />
            <polyline
                className="c feature-stroke no-fill"
                points="84.04 277.94 84.04 281.6 119.09 281.6 119.09 278.99 127.98 278.99" />
            <line
                className="c feature-stroke no-fill"
                x1="75.67"
                y1="201.57"
                x2="88.75"
                y2="201.57" />
            <line
                className="c feature-stroke no-fill"
                x1="75.67"
                y1="197.91"
                x2="75.67"
                y2="206.28" />
            <line
                className="c feature-stroke no-fill"
                x1="88.75"
                y1="197.91"
                x2="88.75"
                y2="206.28" />
            <line
                className="d feature-stroke no-fill"
                x1="212.68"
                y1="91.03"
                x2="212.68"
                y2="109.17" />
            <line
                className="d feature-stroke no-fill"
                x1="225.23"
                y1="96.96"
                x2="225.23"
                y2="109.17" />
            <line
                className="d feature-stroke no-fill"
                x1="244.76"
                y1="79.52"
                x2="244.76"
                y2="109.17" />
            <line
                className="d feature-stroke no-fill"
                x1="229.07"
                y1="110.21"
                x2="229.07"
                y2="147.17" />
            <line
                className="d feature-stroke no-fill"
                x1="239.53"
                y1="109.17"
                x2="239.53"
                y2="143.34" />
            <polyline
                className="d feature-stroke no-fill"
                points="225.93 147.87 225.93 175.77 214.07 175.77 214.07 169.84" />
            <line
                className="d feature-stroke no-fill"
                x1="213.72"
                y1="147.87"
                x2="213.72"
                y2="159.38" />
            <line
                className="d feature-stroke no-fill"
                x1="201.17"
                y1="148.22"
                x2="201.17"
                y2="174.72" />
            <polyline
                className="d feature-stroke no-fill"
                points="187.57 175.07 181.64 170.89 181.64 148.22" />
            <line
                className="d feature-stroke no-fill"
                x1="232.2"
                y1="356.05"
                x2="232.2"
                y2="389.53" />
            <line
                className="d feature-stroke no-fill"
                x1="240.57"
                y1="356.4"
                x2="240.57"
                y2="413.94" />
            <line
                className="d feature-stroke no-fill"
                x1="214.77"
                y1="384.65"
                x2="259.4"
                y2="384.65" />
            <line
                className="d feature-stroke no-fill"
                x1="129.68"
                y1="432.77"
                x2="164.55"
                y2="432.77" />
            <line
                className="d feature-stroke no-fill"
                x1="130.03"
                y1="440.79"
                x2="164.55"
                y2="440.79" />
            <line
                className="d feature-stroke no-fill"
                x1="101.09"
                y1="424.05"
                x2="101.09"
                y2="452.3" />
            <line
                className="d feature-stroke no-fill"
                x1="90.28"
                y1="423.7"
                x2="106.67"
                y2="423.7" />
            <line
                className="d feature-stroke no-fill"
                x1="214.42"
                y1="389.18"
                x2="220"
                y2="384.3" />
            <polygon
                className="e building-fill"
                points="149.54 97.32 151.71 101.65 148.1 103.09 146.66 121.14 143.04 121.86 137.27 109.59 140.16 102.37 149.54 97.32" />
            <rect
                className="e building-fill"
                x="220.92"
                y="339.69"
                width="16.6"
                height="7.22" />
            <rect
                className="e building-fill"
                x="248.15"
                y="273.28"
                width="9.02"
                height="9.03" />
            <rect
                className="e building-fill"
                x="248.15"
                y="287"
                width="9.02"
                height="9.03" />
            <rect
                className="e building-fill"
                x="271.25"
                y="292.05"
                width="9.02"
                height="9.03" />
            <rect
                className="e building-fill"
                x="270.89"
                y="277.98"
                width="9.03"
                height="9.02" />
            <rect
                className="e building-fill"
                x="311.58"
                y="234.93"
                width="20.21"
                height="5.05" />
            <rect
                className="e building-fill"
                x="311.58"
                y="237.21"
                width="14.8"
                height="11.69" />
            <rect
                className="e building-fill"
                x="251.58"
                y="289.53"
                width="9.02"
                height="4.33" />
            <rect
                className="e building-fill"
                x="164.18"
                y="348.36"
                width="20.22"
                height="7.22" />
            <rect
                className="e building-fill"
                x="62.39"
                y="113.16"
                width="13.36"
                height="7.22" />
            <rect
                className="e building-fill"
                x="67.41"
                y="131.8"
                width="14.8"
                height="5.41" />
            <rect
                className="e building-fill"
                x="91.69"
                y="104.37"
                width="5.41"
                height="11.55"
                transform="translate(-16.51 203.64) rotate(-89.53)" />
            <rect
                className="e building-fill"
                x="200.21"
                y="88.62"
                width="5.41"
                height="8.8" />
            <rect
                className="e building-fill"
                x="235.43"
                y="82.09"
                width="8.12"
                height="13.13" />
            <rect
                className="e building-fill"
                x="108.39"
                y="115.58"
                width="8.3"
                height="5.41" />
            <rect
                className="e building-fill"
                x="163.71"
                y="141.2"
                width="4.69"
                height="14.89" />
            <rect
                className="e building-fill"
                x="158.44"
                y="109.45"
                width="5.42"
                height="5.41" />
            <rect
                className="e building-fill"
                x="194.43"
                y="105.84"
                width="5.42"
                height="5.41" />
            <rect
                className="e building-fill"
                x="158.77"
                y="114.5"
                width="9.81"
                height="5.41" />
            <rect
                className="e building-fill"
                x="194.22"
                y="109.81"
                width="9.81"
                height="5.41" />
            <rect
                className="e building-fill"
                x="106.77"
                y="136.65"
                width="10.47"
                height="8.12" />
            <rect
                className="e building-fill"
                x="87.6"
                y="141.34"
                width="7.22"
                height="4.51" />
            <rect
                className="e building-fill"
                x="179.49"
                y="423.02"
                width="12.27"
                height="15.34" />
            <rect
                className="e building-fill"
                x="118.3"
                y="242.57"
                width="10.35"
                height="10.05" />
            <rect
                className="e building-fill"
                x="80.1"
                y="228.72"
                width="8.96"
                height="5.62"
                transform="translate(-4.82 1.82) rotate(-1.2)" />
            <rect
                className="e building-fill"
                x="54.01"
                y="256.93"
                width="14.68"
                height="13.42" />
            <rect
                className="e building-fill"
                x="109.72"
                y="213.77"
                width="10.35"
                height="9.08" />
            <rect
                className="e building-fill"
                x="60.35"
                y="292.22"
                width="7.82"
                height="5.11" />
            <rect
                className="e building-fill"
                x="112.97"
                y="295.63"
                width="7.82"
                height="5.11" />
            <rect
                className="e building-fill"
                x="103.76"
                y="268.77"
                width="6.02"
                height="11.19" />
            <rect
                className="e building-fill"
                x="69.65"
                y="280.83"
                width="3.49"
                height="6.01" />
            <rect
                className="e building-fill"
                x="89.71"
                y="281.77"
                width="4.36"
                height="3.85" />
            <rect
                className="e building-fill"
                x="110.63"
                y="282.03"
                width="4.36"
                height="3.85" />
            <rect
                className="e building-fill"
                x="115.38"
                y="261.06"
                width="4.36"
                height="3.85" />
            <rect
                className="e building-fill"
                x="64.85"
                y="233.37"
                width="4.36"
                height="3.85"
                transform="translate(-129.48 89.56) rotate(-37.54)" />
            <rect
                className="e building-fill"
                x="69.32"
                y="213.25"
                width="4.36"
                height="3.85"
                transform="translate(-18.51 7.06) rotate(-5.01)" />
            <rect
                className="e building-fill"
                x="111.16"
                y="217.51"
                width="5.17"
                height="9.08" />
            <rect
                className="e building-fill"
                x="109.51"
                y="245.07"
                width="12.27"
                height="7.55" />
            <rect
                className="e building-fill"
                x="60.83"
                y="252.77"
                width="10.91"
                height="7.55" />
            <rect
                className="e building-fill"
                x="67.09"
                y="246.51"
                width="18.13"
                height="7.55" />
            <rect
                className="e building-fill"
                x="76.87"
                y="244.59"
                width="7.38"
                height="7.55" />
            <rect
                className="e building-fill"
                x="168.15"
                y="409.15"
                width="7.1"
                height="8.12" />
            <rect
                className="e building-fill"
                x="147.57"
                y="350.43"
                width="7.54"
                height="7.16" />
            <rect
                className="e building-fill"
                x="172.55"
                y="326.41"
                width="15.96"
                height="4.03" />
            <rect
                className="e building-fill"
                x="178.68"
                y="329.84"
                width="9.83"
                height="4.03" />
            <rect
                className="e building-fill"
                x="148.52"
                y="354.23"
                width="5.97"
                height="5.67" />
            <rect
                className="e building-fill"
                x="150.81"
                y="400"
                width="4.88"
                height="11.01" />
            <rect
                className="e building-fill"
                x="109.42"
                y="374.98"
                width="4.88"
                height="11.01" />
            <rect
                className="e building-fill"
                x="109.9"
                y="404.94"
                width="4.88"
                height="5.59" />
            <rect
                className="e building-fill"
                x="385.02"
                y="288.09"
                width="12.27"
                height="4.51" />
            <rect
                className="e building-fill"
                x="350.53"
                y="371.2"
                width="3.97"
                height="11.55" />
            <rect
                className="e building-fill"
                x="466.59"
                y="369.68"
                width="3.97"
                height="11.55" />
            <rect
                className="e building-fill"
                x="447.96"
                y="271.38"
                width="3.97"
                height="11.55" />
            <rect
                className="e building-fill"
                x="464.6"
                y="298.13"
                width="3.97"
                height="11.55" />
            <rect
                className="e building-fill"
                x="243.94"
                y="332.23"
                width="4.96"
                height="15.4" />
            <rect
                className="e building-fill"
                x="270.9"
                y="328.86"
                width="4.96"
                height="11.55" />
            <rect
                className="e building-fill"
                x="271.38"
                y="361.59"
                width="4.96"
                height="17.8" />
            <rect
                className="e building-fill"
                x="254.95"
                y="322.16"
                width="17.81"
                height="6.07"
                transform="translate(-147.02 244.24) rotate(-39.8)" />
            <polygon
                className="e building-fill"
                points="198.41 333.62 193.58 329.94 202.04 318.83 206.87 322.51 198.41 333.62" />
            <polygon
                className="e building-fill"
                points="157.88 127.45 152.41 123.29 160.87 112.19 166.33 116.35 157.88 127.45" />
            <rect
                className="e building-fill"
                x="191.45"
                y="129.04"
                width="13.96"
                height="6.87"
                transform="matrix(0.76, -0.66, 0.66, 0.76, -38.28, 162.37)" />
            <polygon
                className="e building-fill"
                points="192.24 121.31 186.78 117.16 195.23 106.05 200.7 110.21 192.24 121.31" />
            <polygon
                className="e building-fill"
                points="193.39 380.14 188.56 376.46 197.01 365.35 201.85 369.03 193.39 380.14" />
            <polygon
                className="e building-fill"
                points="144.67 396.16 138.91 394.23 143.72 379.98 149.47 381.92 144.67 396.16" />
            <polygon
                className="e building-fill"
                points="139.01 375.95 135.85 372.85 143.54 365.03 146.7 368.14 139.01 375.95" />
            <polygon
                className="e building-fill"
                points="240.49 379.79 236.99 377.08 243.7 368.42 247.2 371.13 240.49 379.79" />
            <polygon
                className="e building-fill"
                points="462.83 335.52 459.92 332.19 468.17 324.98 471.09 328.32 462.83 335.52" />
            <polygon
                className="e building-fill"
                points="125.78 409.4 122.62 406.3 130.31 398.49 133.46 401.59 125.78 409.4" />
            <polygon
                className="e building-fill"
                points="269.1 357.72 265.41 360.16 259.37 351.02 263.06 348.58 269.1 357.72" />
            <polygon
                className="e building-fill"
                points="103.51 130.28 97.95 135.43 88.54 125.26 94.1 120.11 103.51 130.28" />
            <polygon
                className="e building-fill"
                points="152.54 140.81 147.69 143.92 140.22 132.25 145.07 129.14 152.54 140.81" />
            <polygon
                className="e building-fill"
                points="167.74 141.41 165.17 145.57 153.39 138.27 155.96 134.12 167.74 141.41" />
            <polygon
                className="e building-fill"
                points="205.81 118.17 201.69 123.19 190.98 114.39 195.1 109.37 205.81 118.17" />
            <polygon
                className="e building-fill"
                points="232.85 127.84 227.25 131.12 220.25 119.16 225.86 115.87 232.85 127.84" />
            <polygon
                className="e building-fill"
                points="226.91 368.05 222.07 371.26 214.55 359.88 219.4 356.67 226.91 368.05" />
            <polygon
                className="e building-fill"
                points="133.32 379.31 131.44 384.81 118.54 380.39 120.43 374.89 133.32 379.31" />
            <polygon
                className="e building-fill"
                points="107 255.17 102.88 263.2 88.92 256.04 93.03 248.01 107 255.17" />
            <polygon
                className="e building-fill"
                points="146.48 446.46 143.32 443.36 151 435.55 154.16 438.65 146.48 446.46" />
            <polygon
                className="e building-fill"
                points="80.1 234.03 77.83 229.49 91.6 222.64 93.86 227.18 80.1 234.03" />
            <polygon
                className="e building-fill"
                points="317.53 256.77 317.53 245.58 325.83 245.58 325.83 248.89 317.53 256.77" />
            <circle className="e building-fill" cx="271.45" cy="388.06" r="4.33" />
            <rect
                className="e building-fill"
                x="54.01"
                y="256.93"
                width="8.42"
                height="20.64" />
            <rect
                className="e building-fill"
                x="56.05"
                y="265.23"
                width="10.66"
                height="9.77"
                transform="translate(-155.53 97.84) rotate(-38.74)" />
            <path
                className="f no-fill border-stroke"
                d="M38.72,109.57H54.41V94.67h69v-22H165V86.82h24.32v11h7.06V81.33h5.49V62.5h42.37V79h25.1v25.89h36.09v7.06s66.53-1.25,88.66,0,59.86,25.31,68.26,56.49c3.06,11.36,0,47.07,0,47.07L455.32,221v38.45h18.83v22H482V407.71H468.66v11.77H332.93V374.76h8.63v-80l17.26-18h24.32V259.43h50.22v-33l-6.28-9.41V181.75s-1.21-31.37-42.37-34.52c-35.2-2.69-141.22,0-141.22,0v45.51H162.68v-9.42l3.93-7.06L157.19,181h-7.06v-5.49H136.79V150.37h-11v12.55H69.32V147.23l-11-7.06H38.72Z" />
            <polygon
                className="f no-fill border-stroke"
                points="273 215.17 286.08 203.67 329.5 203.67 343.1 216.22 343.1 264.34 333.16 277.42 294.97 277.42 294.97 285.79 301.25 292.59 301.25 300.43 296.02 306.71 290.79 306.71 286.6 310.89 275.1 310.89 275.1 316.65 286.6 316.65 294.97 326.06 294.97 355.88 287.65 355.88 287.65 405.05 262.02 405.05 262.02 414.46 195.07 414.46 195.07 457.35 160.54 457.35 152.18 463.63 139.62 463.63 139.62 459.97 135.44 459.97 135.44 463.63 83.13 463.63 83.13 434.34 69.53 434.34 69.53 397.2 89.93 397.2 94.11 391.45 87.84 381.51 87.84 353.26 117.65 353.26 117.65 356.05 136.48 356.05 136.48 330.77 159.5 330.77 165.25 325.54 187.74 325.54 187.74 312.99 251.03 312.99 251.03 318.74 254.17 318.74 254.17 310.37 231.16 310.37 231.16 261.2 258.88 261.2 258.88 258.06 269.87 258.06 269.87 263.3 273 263.3 273 215.17" />
            <polygon
                className="f no-fill border-stroke"
                points="55.8 238.71 33.3 238.71 33.3 262.77 50.57 262.77 50.57 278.99 34.87 278.99 34.87 300.43 92.94 300.43 92.94 311.94 131.12 311.94 131.12 212.03 90.32 212.03 90.32 196.87 55.8 196.87 55.8 238.71" />
        </SVGOverlay>
    ),
    forsakenUnderground: (
        <SVGOverlay attributes={{ viewBox: '0 0 512 512' }} bounds={ImageBounds}>
            <defs>
                <style>
                    {globalStyle}
                    {`
                .c,.d,.e{strokeMiterlimit:10;}
                .c{strokeWidth:0.96px;}
                .d,.e{sstrokeWidth:0.39px;}
                .e{stroke-dasharray:1.94;}
                `}
                </style>
            </defs>
            <rect className="a background-fill" width="512" height="512" />
            <path
                className="b field-fill"
                d="M475.09,310.64V287.35h-7.51V186.18H425.67V196H347V178.68h7.25V151.77H340.55l-20.7-19.15v-9.83H292.42c-22.51-2.59-23-22.26-23-22.26h-81.5c.78,14.49-16.81,21.74-16.81,21.74H137.44v9.83L117,151.51H104.32v27.17h6.21v15.78h-4.14v6.73H64.74L64,198.86H45.85v-2.59h-14l.26,36.48H45.33l2.59-2.59H63.19L65,228.35H91.39v1.81h15.26l.78,3.37H125.8l2.33-2.85h17.33V240h16.3v9.83h-2.33v39.33c-.51,28.2,30.28,38,30.28,38H216.1v21.21H375.22V333.15h39.07V325.9h7.5v51.24h5.43v5.43h-4.4V463h51V382.83h-4.65v-6.21h4.91V325.9H480V310.64ZM334,194.52H306.26v-4.46H250l-.19-11.84h21.53V156.49H301l14.56,14.16v7.57H334Z" />
            <path
                className="a background-fill"
                d="M175.73,240.26v7.24h2.59v40.63s0,20.18,19.41,20.44h18.11V287.09H375.22v15H414.8v8.28h5.95V286.57H428V244.92h-2.85V234.05H306.91v5.69Z" />
            <polygon
                className="a background-fill"
                points="123.86 178.42 141.52 178.42 141.52 171.04 155.49 157.26 185.56 157.26 185.56 177.84 207.3 177.84 207.3 189.48 144.62 189.48 144.62 196.27 123.66 196.27 123.86 178.42" />
            <polygon
                className="c no-fill border-stroke"
                points="249.79 178.22 271.33 178.22 271.33 156.49 301.02 156.49 315.58 170.66 315.58 178.22 334.01 178.22 334.01 194.52 306.26 194.52 306.26 190.06 249.99 190.06 249.79 178.22" />
            <line
                className="d feature-stroke no-fill"
                x1="149.47"
                y1="208.3"
                x2="170.43"
                y2="208.3" />
            <line
                className="d feature-stroke no-fill"
                x1="149.86"
                y1="221.11"
                x2="170.43"
                y2="221.11" />
            <line
                className="d feature-stroke no-fill"
                x1="158.4"
                y1="189.67"
                x2="158.4"
                y2="208.3" />
            <line
                className="d feature-stroke no-fill"
                x1="158.01"
                y1="221.11"
                x2="158.01"
                y2="239.35" />
            <line
                className="d feature-stroke no-fill"
                x1="161.7"
                y1="240.91"
                x2="175.86"
                y2="240.91" />
            <line
                className="d feature-stroke no-fill"
                x1="207.3"
                y1="181.13"
                x2="249.99"
                y2="181.13" />
            <line
                className="d feature-stroke no-fill"
                x1="268.62"
                y1="202.29"
                x2="268.62"
                y2="225.77" />
            <line
                className="d feature-stroke no-fill"
                x1="268.81"
                y1="190.06"
                x2="268.81"
                y2="192" />
            <line
                className="d feature-stroke no-fill"
                x1="268.62"
                y1="239.93"
                x2="268.62"
                y2="237.8" />
            <polyline
                className="d feature-stroke no-fill"
                points="286.28 239.74 286.28 221.11 308.2 221.11" />
            <polyline
                className="d feature-stroke no-fill"
                points="308.2 207.91 286.28 207.91 286.28 189.87" />
            <line
                className="d feature-stroke no-fill"
                x1="424.25"
                y1="196.08"
                x2="424.25"
                y2="233.92" />
            <line
                className="d feature-stroke no-fill"
                x1="427.93"
                y1="285.93"
                x2="441.32"
                y2="285.93" />
            <line
                className="d feature-stroke no-fill"
                x1="455.29"
                y1="285.93"
                x2="467.32"
                y2="285.93" />
            <polyline
                className="d feature-stroke no-fill"
                points="421.72 326.1 424.25 326.1 424.25 309.6 420.75 309.6" />
            <line
                className="d feature-stroke no-fill"
                x1="375.93"
                y1="302.03"
                x2="375.93"
                y2="311.35" />
            <line
                className="d feature-stroke no-fill"
                x1="376.32"
                y1="324.16"
                x2="376.32"
                y2="332.89" />
            <line
                className="e feature-stroke no-fill"
                x1="215.06"
                y1="327.46"
                x2="215.06"
                y2="325.32" />
            <line
                className="e feature-stroke no-fill"
                x1="215.25"
                y1="311.54"
                x2="215.25"
                y2="308.63" />
            <line
                className="e feature-stroke no-fill"
                x1="256.59"
                y1="190.06"
                x2="256.59"
                y2="206.56" />
            <line
                className="e feature-stroke no-fill"
                x1="256.98"
                y1="223.05"
                x2="256.98"
                y2="239.74" />
            <rect
                className="e feature-stroke no-fill"
                x="197.01"
                y="207.53"
                width="2.91"
                height="14.17" />
            <circle className="f building-fill" cx="228.64" cy="139.99" r="24.84" />
            <circle className="f building-fill" cx="176.25" cy="139.99" r="4.27" />
            <circle className="f building-fill" cx="137.44" cy="152.02" r="4.27" />
            <circle className="f building-fill" cx="318.68" cy="152.02" r="4.27" />
            <circle className="f building-fill" cx="280.65" cy="140.38" r="4.27" />
            <rect
                className="f building-fill"
                x="219.72"
                y="205.59"
                width="14.75"
                height="12.42" />
            <rect
                className="f building-fill"
                x="239.51"
                y="299.12"
                width="18.24"
                height="11.26" />
            <rect
                className="f building-fill"
                x="239.51"
                y="324.35"
                width="17.72"
                height="11.26" />
            <rect
                className="f building-fill"
                x="269.27"
                y="309.09"
                width="12.55"
                height="17.21" />
            <rect
                className="f building-fill"
                x="301.09"
                y="306.76"
                width="5.56"
                height="21.61" />
            <rect
                className="f building-fill"
                x="322.56"
                y="310.9"
                width="34.28"
                height="12.81" />
            <rect
                className="f building-fill"
                x="301.35"
                y="287.61"
                width="5.3"
                height="2.46" />
            <rect
                className="f building-fill"
                x="301.35"
                y="345.12"
                width="5.3"
                height="2.46" />
            <rect
                className="f building-fill"
                x="371.46"
                y="205.59"
                width="22.12"
                height="16.69" />
            <polygon
                className="f building-fill"
                points="438.61 328.23 457.75 328.23 457.75 336.51 453.1 340.65 444.04 340.65 439.12 337.03 438.61 328.23" />
            <polygon
                className="f building-fill"
                points="448.44 397.84 438.09 392.4 438.09 377.65 443 372.22 452.84 372.22 458.01 377.65 458.01 392.14 448.44 397.84" />
            <path
                className="c no-fill border-stroke"
                d="M31.88,196.27h14v2.59H64l.78,2.33h41.65v-6.73h4.14V178.68h-6.21V151.51H117l20.44-19.41v-9.83h33.64s17.59-7.25,16.81-21.74h81.5s.52,19.67,23,22.26h27.43v9.83l20.7,19.15h13.71v26.91H347V196h78.66v-9.83h41.91V287.35h7.51v23.29H480V325.9h-5.95v50.72h-4.91v6.21h4.65V463h-51V382.57h4.4v-5.43h-5.43V325.9h-7.5v7.25H375.22v15.26H216.1V327.2H189.71s-30.79-9.84-30.28-38V249.83h2.33V240h-16.3v-9.32H128.13l-2.33,2.85H107.43l-.78-3.37H91.39v-1.81H65l-1.81,1.81H47.92l-2.59,2.59H32.14Z" />
            <path
                className="c no-fill border-stroke"
                d="M175.73,240.26v7.24h2.59v40.63s0,20.18,19.41,20.44h18.11V287.09H375.22v15H414.8v8.28h5.95V286.57H428V244.92h-2.85V234.05H306.91v5.69Z" />
            <polygon
                className="c no-fill border-stroke"
                points="123.86 178.42 141.52 178.42 141.52 171.04 155.49 157.26 185.56 157.26 185.56 177.84 207.3 177.84 207.3 189.48 144.62 189.48 144.62 196.27 123.66 196.27 123.86 178.42" />
        </SVGOverlay>
    ),
};
